// globals
class pageCollection {
  constructor() {
    this.pages = $('.p-collection');
    this.setting = $('.p-collection-settings');
    this.categories = $('.p-collection-category');

    if (!this.pages.length) {
      return;
    }

    if (!this.setting.length) {
      return;
    }

    this.init();
  }

  init() {
    this.setting.click(() => {
      this.toggleSettings();
    });
  }

  toggleSettings() {
    this.categories.slideToggle();
  }

}

class pageRegister {
  constructor() {
    this.pages = $('.p-register');
    this.btn = $('.p-register .c-btn');
    this.check = $('.p-register #policy');
    this.state = '--disable';
    this.inputName = document.getElementById('last_name');
    this.inputEmail = document.getElementById('email');
    this.inputPass = document.getElementById('create_password');

    if (!this.pages.length) {
      return;
    }

    this.init();
    this.checkName();
    this.checkEmail();
    this.checkPass();
  }

  init() {
    this.check.on('click', () => {
      this.checkPolicy();
    });
  }

  checkName() {
    this.inputName.addEventListener('input', () => {
      if (this.inputName.value != "") {
        $('.field-error.--name').css('display', 'none');
      } else {
        $('.field-error.--name').css('display', 'block');
        this.btn.addClass(this.state);
        $('.c-privacy-check input[type="checkbox"]').removeAttr('checked').prop('checked', false).change();
      }
    });
  }

  checkEmail() {
    this.inputEmail.addEventListener('input', () => {
      if (this.inputEmail.value != "") {
        $('.field-error.--email').css('display', 'none');
      } else {
        $('.field-error.--email').css('display', 'block');
        this.btn.addClass(this.state);
        $('.c-privacy-check input[type="checkbox"]').removeAttr('checked').prop('checked', false).change();
      }
    });
  }

  checkPass() {
    this.inputPass.addEventListener('input', () => {
      if (this.inputPass.value != "") {
        $('.field-error.--pass').css('display', 'none');
      } else {
        $('.field-error.--pass').css('display', 'block');
        this.btn.addClass(this.state);
        $('.c-privacy-check input[type="checkbox"]').removeAttr('checked').prop('checked', false).change();
      }
    });
  }

  checkPolicy() {
    this.checkState = this.check.prop('checked');

    if (this.checkState != true) {
      this.btn.addClass(this.state);
    } else {
      if (this.inputName.value != "" && this.inputEmail.value != "" && this.inputPass.value != "") {
        this.btn.removeClass(this.state);
      } else {
        this.btn.addClass(this.state);
      }
    }
  }

}

class pageInquiry {
  constructor() {
    this.pages = $('.p-inquiry');
    this.btn = $('.p-inquiry .c-btn');
    this.check = $('.p-inquiry #policy');
    this.state = '--disable';
    this.inputName = document.getElementById('contactFormName');
    this.inputEmail = document.getElementById('contactFormEmail');
    this.inputTitle = document.getElementById('contactFormTitle');
    this.inputContent = document.getElementById('contactFormMessage');

    if (!this.pages.length) {
      return;
    }

    this.init();
    this.checkName();
    this.checkEmail();
    this.checkTitle();
    this.checkContent();
  }

  init() {
    this.check.on('click', () => {
      this.checkPolicy();
    });
  }

  checkName() {
    this.inputName.addEventListener('input', () => {
      if (this.inputName.value != "") {
        $('.field-error .--name').css('display', 'none');
      } else {
        $('.field-error .--name').css('display', 'block');
        this.btn.addClass(this.state);
        $('.c-privacy-check input[type="checkbox"]').removeAttr('checked').prop('checked', false).change();
      }
    });
  }

  checkEmail() {
    this.inputEmail.addEventListener('input', () => {
      if (this.inputEmail.value != "") {
        $('.field-error .--email').css('display', 'none');
      } else {
        $('.field-error .--email').css('display', 'block');
        this.btn.addClass(this.state);
        $('.c-privacy-check input[type="checkbox"]').removeAttr('checked').prop('checked', false).change();
      }
    });
  }

  checkTitle() {
    this.inputTitle.addEventListener('input', () => {
      if (this.inputTitle.value != "") {
        $('.field-error .--title').css('display', 'none');
      } else {
        $('.field-error .--title').css('display', 'block');
        this.btn.addClass(this.state);
        $('.c-privacy-check input[type="checkbox"]').removeAttr('checked').prop('checked', false).change();
      }
    });
  }

  checkContent() {
    this.inputContent.addEventListener('input', () => {
      if (this.inputContent.value != "") {
        $('.field-error .--content').css('display', 'none');
      } else {
        $('.field-error .--content').css('display', 'block');
        this.btn.addClass(this.state);
        $('.c-privacy-check input[type="checkbox"]').removeAttr('checked').prop('checked', false).change();
      }
    });
  }

  checkPolicy() {
    this.checkState = this.check.prop('checked');

    if (this.checkState != true) {
      this.btn.addClass(this.state);
    } else {
      if (this.inputName.value != "" && this.inputEmail.value != "" && this.inputTitle.value != "" && this.inputContent.value != "") {
        this.btn.removeClass(this.state);
      } else {
        this.btn.addClass(this.state);
      }
    }
  }

}

class pageProduct {
  constructor() {
    this.pages = $('.p-productDetail');
    this.btnWrap = $('.p-productDetail .block.type-buy_buttons .buttons .shopify-payment-button');
    this.openButton = document.querySelector('.c-size-modal-trriger');
    this.modalDialog = document.querySelector('.c-size-modal');
    this.closeButton = document.querySelector('.c-size-modal-close');

    if (!this.pages.length) {
      return;
    }

    if (!this.openButton) {
      return;
    }

    this.init();
  }

  init() {
    this.btnWrap.css('opacity', '1');
    this.btnWrap.css('visibility', 'visible'); // モーダルを開く

    this.openButton.addEventListener('click', async () => {
      this.openModal();
    }); // モーダルを閉じる

    this.closeButton.addEventListener('click', () => {
      this.closeModal();
    });
    this.modalDialog.addEventListener('click', event => {
      if (event.target.closest('.c-size-modal__container') === null) {
        this.closeModal();
      }
    });
  }

  openModal() {
    this.modalDialog.showModal(); // モーダルダイアログを表示する際に背景部分がスクロールしないようにする

    document.documentElement.style.overflow = "hidden";
  }

  closeModal() {
    this.modalDialog.close(); // モーダルを解除すると、スクロール可能になる

    document.documentElement.removeAttribute("style");
  }

}

class jsHeader {
  constructor() {
    this.header = document.querySelector('.section-header');
    this.headerHeight = 104;
    this.beforePos = 0;
    this.init();
    this.setupScrollHandler();
    this.clickedAddToCart();
  }

  updateClass(_state) {
    this.hidden = '--header_hidden';
    this.visible = '--header_visible';

    if (_state != 'hidden') {
      document.body.classList.remove(this.hidden);
      document.body.classList.add(this.visible);
    } else {
      document.body.classList.remove(this.visible);
      document.body.classList.add(this.hidden);
    }
  }

  init() {
    this.updateClass('visible');
  }

  setupScrollHandler() {
    // 既存のスクロールイベントリスナーを保存
    const originalScrollHandler = window.onscroll;

    window.onscroll = event => {
      // 元のスクロールハンドラーを呼び出す
      if (typeof originalScrollHandler === 'function') {
        originalScrollHandler(event);
      } // 新しいスクロール処理を追加


      this.handleScroll();
    };
  }

  handleScroll() {
    const scrollPos = window.pageYOffset || document.documentElement.scrollTop;
    const slidePos = document.querySelector('.main').offsetTop - this.headerHeight;

    if (scrollPos === this.beforePos) {// スクロール位置が変わっていない場合は何もしない
    } else if (slidePos > scrollPos || 0 > scrollPos - this.beforePos) {
      this.updateClass('visible');
    } else {
      this.updateClass('hidden');
    }

    this.beforePos = scrollPos;
  } // カート追加を押した場合


  clickedAddToCart() {
    this.btn = document.querySelector('.add-to-cart');

    if (!this.btn) {
      return;
    }

    this.btn.addEventListener('click', () => {
      this.updateClass('visible');
    });
  }

}

class pageTop {
  constructor() {
    this.elm = $('.c-pagetop button');

    if (!this.elm.length) {
      return;
    }

    this.init();
  }

  init() {
    this.elm.click(() => {
      this.scrollTop();
    });
  }

  scrollTop() {
    $('html, body').animate({
      scrollTop: 0
    }, 600);
  }

}

class Lottie {
  constructor() {
    this.el = $('.js-lottie');

    if (!this.el.length) {
      return;
    }

    this.init();
  }

  init() {
    this.page = $('body').attr('id');
    this.flag = '404-not-found';
    console.log(this.page);

    if (this.page != this.flag) {
      this.page_default();
    } else {
      this.page_404();
    }
  }

  getPath() {
    return CFL.Assets.base();
  }

  page_404() {
    let animationData = {
      "v": "5.9.2",
      "fr": 30,
      "ip": 0,
      "op": 90,
      "w": 170,
      "h": 70,
      "nm": "404_komaru",
      "ddd": 0,
      "assets": [{
        "id": "comp_0",
        "nm": "komaru_eye1",
        "fr": 30,
        "layers": [{
          "ddd": 0,
          "ind": 1,
          "ty": 4,
          "nm": "fuci Rアウトライン",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [152.603, 55.142, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [38.345, 46.977, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [-22.328, 0], [-0.785, -4.322], [0, 0], [-0.014, -2.759], [31.441, 1.209], [0, 0], [-1.238, 4.631], [-0.05, 0.183]],
                  "o": [[1.252, -4.685], [23.02, 0], [0, 0], [0.512, 3.1], [0.099, 16.325], [-29.677, -1.137], [0.192, -6.413], [0.05, -0.185], [0, 0]],
                  "v": [[-28.576, -15.589], [1.72, -40.585], [30.992, -11.708], [31.099, -11.049], [31.854, -2.176], [-2.276, 39.376], [-31.184, 2.404], [-28.945, -14.081], [-28.796, -14.633]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [38.345, 46.977],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 90,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 2,
          "ty": 4,
          "nm": "mabutaアウトライン 2",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [155.365, 38.803, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [35.133, 24.55, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [{
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 0,
                  "s": [{
                    "i": [[0, 0], [-11.622, -5.706], [-13.102, -3.381]],
                    "o": [[0, 0], [13.394, 6.575], [0, 0]],
                    "v": [[-27.99, -12.857], [-8.242, -0.951], [28.74, 13.419]],
                    "c": false
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 10,
                  "s": [{
                    "i": [[0, 0], [-12.691, -2.562], [-7.355, -5.71]],
                    "o": [[0, 0], [18.127, 3.66], [0, 0]],
                    "v": [[-27.302, -12.919], [-5.492, -10.701], [28.49, 1.669]],
                    "c": false
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 50,
                  "s": [{
                    "i": [[0, 0], [-12.691, -2.562], [-7.355, -5.71]],
                    "o": [[0, 0], [18.127, 3.66], [0, 0]],
                    "v": [[-27.302, -12.919], [-5.492, -10.701], [28.49, 1.669]],
                    "c": false
                  }]
                }, {
                  "t": 60,
                  "s": [{
                    "i": [[0, 0], [-11.622, -5.706], [-13.102, -3.381]],
                    "o": [[0, 0], [13.394, 6.575], [0, 0]],
                    "v": [[-27.99, -12.857], [-8.242, -0.951], [28.74, 13.419]],
                    "c": false
                  }]
                }],
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [35.133, 29.288],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 90,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 3,
          "ty": 4,
          "nm": "mabuta kage",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [154.111, 29.838, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.361, 16.088, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "hasMask": true,
          "masksProperties": [{
            "inv": false,
            "mode": "a",
            "pt": {
              "a": 0,
              "k": {
                "i": [[11, 3.25], [8.5, -4.25], [0, 0], [0, 0], [0, 0], [0, 0]],
                "o": [[-11, -3.25], [-8.5, 4.25], [0, 0], [0, 0], [0, 0], [0, 0]],
                "v": [[56, -4.75], [21.5, -2.25], [7.5, 14.75], [14, 19.5], [71.25, 39.75], [76.25, 24.25]],
                "c": true
              },
              "ix": 1
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 3
            },
            "x": {
              "a": 0,
              "k": 0,
              "ix": 4
            },
            "nm": "マスク 1"
          }],
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[20.164, 1.038], [7.494, -26.918], [-0.1, -0.071], [-18.572, -0.625], [-3.925, -9.627], [-0.085, 0.014]],
                  "o": [[0, 0], [0.099, 0.057], [2.83, -6.783], [16.253, 0.555], [0.099, -0.029], [-2.218, -13.438]],
                  "v": [[-0.106, -14.157], [-29.954, 11.639], [-29.641, 11.837], [0.577, -10.844], [29.657, 15.279], [29.954, 15.208]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.874509803922, 0.933333333333, 0.894117647059, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.361, 15.53],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 96,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 4,
          "ty": 4,
          "nm": "mabutaアウトライン",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [155.365, 38.803, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [35.133, 24.55, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [{
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 0,
                  "s": [{
                    "i": [[-2.218, -13.452], [0, 0], [20.189, 9.05], [-0.243, 0.463], [0, 0]],
                    "o": [[0, 0], [0, 0], [-19.677, -8.821], [8.486, -16.144], [25.105, 0.822]],
                    "v": [[27.42, 14.389], [28.565, 20.773], [-0.965, 11.404], [-28.322, -4.514], [-2.641, -20.773]],
                    "c": true
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 10,
                  "s": [{
                    "i": [[-0.453, -7.47], [0, 0], [21.33, 5.875], [-0.243, 0.463], [0, 0]],
                    "o": [[0, 0], [0, 0], [-20.818, -5.734], [8.486, -16.144], [25.105, 0.822]],
                    "v": [[27.17, 9.139], [27.565, 9.023], [3.535, -0.847], [-28.322, -4.514], [-2.641, -20.773]],
                    "c": true
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 50,
                  "s": [{
                    "i": [[-0.453, -7.47], [0, 0], [21.33, 5.875], [-0.243, 0.463], [0, 0]],
                    "o": [[0, 0], [0, 0], [-20.818, -5.734], [8.486, -16.144], [25.105, 0.822]],
                    "v": [[27.17, 9.139], [27.565, 9.023], [3.535, -0.847], [-28.322, -4.514], [-2.641, -20.773]],
                    "c": true
                  }]
                }, {
                  "t": 60,
                  "s": [{
                    "i": [[-2.218, -13.452], [0, 0], [20.189, 9.05], [-0.243, 0.463], [0, 0]],
                    "o": [[0, 0], [0, 0], [-19.677, -8.821], [8.486, -16.144], [25.105, 0.822]],
                    "v": [[27.42, 14.389], [28.565, 20.773], [-0.965, 11.404], [-28.322, -4.514], [-2.641, -20.773]],
                    "c": true
                  }]
                }],
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.945098099054, 0.968627510819, 0.909803981407, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.05, 21.077],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 90,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 5,
          "ty": 4,
          "nm": "kurome",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [{
                "i": {
                  "x": 0.667,
                  "y": 1
                },
                "o": {
                  "x": 0.333,
                  "y": 0
                },
                "t": 0,
                "s": [140.533, 43.329, 0],
                "to": [0, 0, 0],
                "ti": [0, 0, 0]
              }, {
                "i": {
                  "x": 0.667,
                  "y": 0.667
                },
                "o": {
                  "x": 0.333,
                  "y": 0.333
                },
                "t": 10,
                "s": [166.033, 44.204, 0],
                "to": [0, 0, 0],
                "ti": [0, 0, 0]
              }, {
                "i": {
                  "x": 0.667,
                  "y": 1
                },
                "o": {
                  "x": 0.333,
                  "y": 0
                },
                "t": 50,
                "s": [166.033, 44.204, 0],
                "to": [0, 0, 0],
                "ti": [0, 0, 0]
              }, {
                "t": 60,
                "s": [140.533, 43.329, 0]
              }],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [20.385, 16.179, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0.014, 0.014], [-1.878, 0.029], [-0.825, 0.64], [-1.422, -0.227], [1.536, -1.891], [1.906, 0.484]],
                  "o": [[-1.806, -0.484], [0.938, -0.014], [1.663, -1.308], [1.422, 0.228], [-1.536, 1.891], [-0.014, 0]],
                  "v": [[-3.569, 3.285], [-3.1, -0.001], [-0.184, -0.839], [3.129, -3.555], [3.84, 1.408], [-3.512, 3.299]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.478431402468, 0.784313785329, 0.882353001015, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [26.514, 26.207],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-3.534, 0], [0, 1.971], [3.534, 0], [0, -1.971]],
                  "o": [[3.534, 0], [0, -1.971], [-3.534, 0], [0, 1.971]],
                  "v": [[0, 3.57], [6.399, 0.001], [0, -3.57], [-6.399, 0.001]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.996078491211, 0.996078491211, 0.992156922583, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [13.162, 20.135],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [13.088, 0], [0.88, -5.344], [0.002, -0.019], [0, 0], [-20.136, 0]],
                  "o": [[-0.734, -5.626], [-11.444, 0], [-0.003, 0.018], [-0.001, 0], [0, 0], [20.135, 0]],
                  "v": [[17.548, -2.074], [0.38, -15.929], [-17.1, -3.069], [-17.102, -3.012], [-17.107, -3.012], [0, 15.929]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.400000029919, 0.756862804936, 0.870588295133, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [20.385, 16.179],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 90,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 6,
          "ty": 4,
          "nm": "右まぶた影アウトライン",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [170.396, 40.454, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [15.029, -7.765, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [{
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 0,
                  "s": [{
                    "i": [[0, 0], [0, 0], [7.553, 3.965], [0, 0], [0, 0], [-5.683, -3.385]],
                    "o": [[0, 0], [0, 0], [-8.414, -4.417], [0, 0], [0, 0], [7.088, 4.222]],
                    "v": [[-18.596, -10.055], [-19.346, -6.765], [-30.324, -11.794], [-42.279, -20.268], [-40.284, -23.235], [-29.733, -15.801]],
                    "c": true
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 10,
                  "s": [{
                    "i": [[0, 0], [0, 0], [8.78, 0.962], [0, 0], [0, 0], [-6.588, -0.597]],
                    "o": [[0, 0], [0, 0], [-9.447, -1.035], [0, 0], [0, 0], [6.588, 0.597]],
                    "v": [[-14.721, -19.805], [-14.721, -17.515], [-26.949, -19.169], [-42.279, -20.268], [-40.284, -23.235], [-25.733, -22.551]],
                    "c": true
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 50,
                  "s": [{
                    "i": [[0, 0], [0, 0], [8.78, 0.962], [0, 0], [0, 0], [-6.588, -0.597]],
                    "o": [[0, 0], [0, 0], [-9.447, -1.035], [0, 0], [0, 0], [6.588, 0.597]],
                    "v": [[-14.721, -19.805], [-14.721, -17.515], [-26.949, -19.169], [-42.279, -20.268], [-40.284, -23.235], [-25.733, -22.551]],
                    "c": true
                  }]
                }, {
                  "t": 60,
                  "s": [{
                    "i": [[0, 0], [0, 0], [7.553, 3.965], [0, 0], [0, 0], [-5.683, -3.385]],
                    "o": [[0, 0], [0, 0], [-8.414, -4.417], [0, 0], [0, 0], [7.088, 4.222]],
                    "v": [[-18.596, -10.055], [-19.346, -6.765], [-30.324, -11.794], [-42.279, -20.268], [-40.284, -23.235], [-29.733, -15.801]],
                    "c": true
                  }]
                }],
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [13.029, 5.735],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [{
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 0,
                  "s": [{
                    "i": [[0, 0], [0, 0], [7.981, 2.438], [0, 0], [0, 0]],
                    "o": [[0, 0], [0, 0], [-7.981, -2.439], [0, 0], [0, 0]],
                    "v": [[12.779, 3.195], [12.779, 5.485], [0.301, 1.831], [-12.779, -3.268], [-10.784, -5.485]],
                    "c": true
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 10,
                  "s": [{
                    "i": [[0, 0], [0, 0], [7.981, 2.438], [0, 0], [0, 0]],
                    "o": [[0, 0], [0, 0], [-7.981, -2.439], [0, 0], [0, 0]],
                    "v": [[14.779, -10.305], [14.779, -8.015], [2.301, -11.669], [-10.779, -16.768], [-8.784, -18.985]],
                    "c": true
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 50,
                  "s": [{
                    "i": [[0, 0], [0, 0], [7.981, 2.438], [0, 0], [0, 0]],
                    "o": [[0, 0], [0, 0], [-7.981, -2.439], [0, 0], [0, 0]],
                    "v": [[14.779, -10.305], [14.779, -8.015], [2.301, -11.669], [-10.779, -16.768], [-8.784, -18.985]],
                    "c": true
                  }]
                }, {
                  "t": 60,
                  "s": [{
                    "i": [[0, 0], [0, 0], [7.981, 2.438], [0, 0], [0, 0]],
                    "o": [[0, 0], [0, 0], [-7.981, -2.439], [0, 0], [0, 0]],
                    "v": [[12.779, 3.195], [12.779, 5.485], [0.301, 1.831], [-12.779, -3.268], [-10.784, -5.485]],
                    "c": true
                  }]
                }],
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [13.029, 5.735],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 90,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 7,
          "ty": 4,
          "nm": "siromeアウトライン",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [152.013, 56.419, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [32.778, 42.956, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[9.858, 1.082], [6.476, -3.544], [1.433, -2.26], [1.036, -3.212], [0, 0], [0, 0], [-3.607, 3.366], [-8.536, 0], [-2.044, -3.125], [0, 0], [0, 0], [2.314, 8.138], [1.923, 2.464]],
                  "o": [[-4.983, -0.547], [-4.304, 2.355], [-2.765, 4.364], [-0.777, 2.409], [0, 0], [0, 0], [3.607, -3.366], [8.536, 0], [2.044, 3.126], [0, 0], [0, 0], [-1.008, -3.544], [-3.848, -4.93]],
                  "v": [[2.807, -15.177], [-13.31, -11.39], [-22.004, -2.437], [-27.605, 9.823], [-28.857, 17.942], [-29.947, 7.998], [-21.6, -8.685], [1.363, -17.942], [24.087, -5.319], [29.947, 11.581], [27.352, 17.848], [25.419, 5.848], [20.72, -4.236]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [34.521, 19.049],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [0.981, -0.227], [0, 0], [-1.038, 9.513], [0.54, 0.355], [0.199, -6.669], [-29.706, 0], [0.1, 16.324], [0.512, 3.1]],
                  "o": [[-0.825, 0.213], [2.716, 54.378], [-31.128, -2.532], [-0.725, -0.413], [-1.323, 4.749], [0, 0], [29.706, 0], [-0.014, -2.759], [0, 0]],
                  "v": [[31.69, -25.739], [28.974, -25.07], [-1.401, 22.042], [-26.314, -28.156], [-28.219, -29.307], [-30.609, -12.273], [-1.7, 24.701], [32.429, -16.851], [31.676, -25.725]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [32.778, 56.355],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [12.347, 8.565], [6.563, -3.003], [0, 0], [0.199, -6.669], [-29.706, 0], [0.1, 16.324], [0.512, 3.1]],
                  "o": [[0, 0], [-8.009, -3.56], [-14.906, 4.338], [-1.323, 4.749], [0, 0], [29.706, 0], [-0.014, -2.759], [0, 0]],
                  "v": [[31.128, -10.036], [15.125, -36.732], [-8.345, -37.4], [-28.781, -13.605], [-31.17, 3.43], [-2.261, 40.402], [31.867, -1.148], [31.114, -10.023]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 1, 1, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [33.34, 40.653],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 90,
          "st": 0,
          "bm": 0
        }]
      }, {
        "id": "comp_1",
        "nm": "komaru_eye2",
        "fr": 30,
        "layers": [{
          "ddd": 0,
          "ind": 1,
          "ty": 4,
          "nm": "fuci Lアウトライン",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [49.596, 55.142, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [38.345, 46.977, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [-22.328, 0], [-0.785, -4.322], [0, 0], [-0.014, -2.759], [31.441, 1.209], [0, 0], [-1.238, 4.631], [-0.05, 0.183]],
                  "o": [[1.252, -4.685], [23.02, 0], [0, 0], [0.512, 3.1], [0.099, 16.325], [-29.677, -1.137], [0.192, -6.413], [0.05, -0.185], [0, 0]],
                  "v": [[-28.576, -15.589], [1.721, -40.585], [30.993, -11.708], [31.1, -11.049], [31.854, -2.176], [-2.275, 39.376], [-31.184, 2.404], [-28.945, -14.081], [-28.796, -14.633]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [38.345, 46.977],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 90,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 2,
          "ty": 4,
          "nm": "L mabutaアウトライン 3",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [47.206, 37.181, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [35.133, 26.171, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [{
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 0,
                  "s": [{
                    "i": [[0, 0], [14.575, -2.776], [6.784, -2.71]],
                    "o": [[0, 0], [-10.482, 1.997], [0, 0]],
                    "v": [[28.74, -13.419], [-1.924, -10.37], [-26.74, -2.581]],
                    "c": false
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 10,
                  "s": [{
                    "i": [[0, 0], [13.36, -6.564], [6.29, -1.623]],
                    "o": [[0, 0], [-12.335, 6.06], [0, 0]],
                    "v": [[28.74, -13.419], [4.133, 0.986], [-28.74, 13.419]],
                    "c": false
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 50,
                  "s": [{
                    "i": [[0, 0], [13.36, -6.564], [6.29, -1.623]],
                    "o": [[0, 0], [-12.335, 6.06], [0, 0]],
                    "v": [[28.74, -13.419], [4.133, 0.986], [-28.74, 13.419]],
                    "c": false
                  }]
                }, {
                  "t": 60,
                  "s": [{
                    "i": [[0, 0], [14.575, -2.776], [6.784, -2.71]],
                    "o": [[0, 0], [-10.482, 1.997], [0, 0]],
                    "v": [[28.74, -13.419], [-1.924, -10.37], [-26.74, -2.581]],
                    "c": false
                  }]
                }],
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215701234, 0.701960784314, 0.847058883368, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [35.133, 32.531],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 90,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 3,
          "ty": 4,
          "nm": "mabuta kage",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [51.111, 29.838, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.361, 16.088, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "hasMask": true,
          "masksProperties": [{
            "inv": false,
            "mode": "a",
            "pt": {
              "a": 0,
              "k": {
                "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                "v": [[70.25, -9.5], [3.21, -9.5], [-0.79, 32.506], [58.25, 17.006], [67.5, 8.256]],
                "c": true
              },
              "ix": 1
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 3
            },
            "x": {
              "a": 0,
              "k": 0,
              "ix": 4
            },
            "nm": "マスク 1"
          }],
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[20.164, 1.038], [7.494, -26.918], [-0.1, -0.071], [-18.572, -0.625], [-3.925, -9.627], [-0.085, 0.014]],
                  "o": [[0, 0], [0.099, 0.057], [2.83, -6.783], [16.253, 0.555], [0.099, -0.029], [-2.218, -13.438]],
                  "v": [[-0.106, -14.157], [-29.954, 11.639], [-29.641, 11.837], [0.577, -10.844], [29.657, 15.279], [29.954, 15.208]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.874509803922, 0.933333333333, 0.894117647059, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.361, 15.53],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 90,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 4,
          "ty": 4,
          "nm": "L mabutaアウトライン 2",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [47.206, 37.181, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [35.133, 26.171, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [{
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 0,
                  "s": [{
                    "i": [[-2.747, -4.86], [12.244, -4.505], [0, 0], [-0.366, 1.527], [0, 0]],
                    "o": [[0, 0], [-7.661, 2.819], [0.299, -1.69], [7.917, -33.058], [20.164, 1.024]],
                    "v": [[28.635, -3.988], [-9.094, 0.222], [-26.635, 6.773], [-27.213, 9.785], [3.484, -19.378]],
                    "c": true
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 10,
                  "s": [{
                    "i": [[-2.747, -4.86], [24.514, -8.876], [0, 0], [-0.366, 1.527], [0, 0]],
                    "o": [[0, 0], [-7.675, 2.779], [0.299, -1.69], [7.917, -33.058], [20.164, 1.024]],
                    "v": [[28.635, -3.988], [-11.094, 16.722], [-28.635, 23.273], [-27.213, 9.785], [3.484, -19.378]],
                    "c": true
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 50,
                  "s": [{
                    "i": [[-2.747, -4.86], [24.514, -8.876], [0, 0], [-0.366, 1.527], [0, 0]],
                    "o": [[0, 0], [-7.675, 2.779], [0.299, -1.69], [7.917, -33.058], [20.164, 1.024]],
                    "v": [[28.635, -3.988], [-11.094, 16.722], [-28.635, 23.273], [-27.213, 9.785], [3.484, -19.378]],
                    "c": true
                  }]
                }, {
                  "t": 60,
                  "s": [{
                    "i": [[-2.747, -4.86], [12.244, -4.505], [0, 0], [-0.366, 1.527], [0, 0]],
                    "o": [[0, 0], [-7.661, 2.819], [0.299, -1.69], [7.917, -33.058], [20.164, 1.024]],
                    "v": [[28.635, -3.988], [-9.094, 0.222], [-26.635, 6.773], [-27.213, 9.785], [3.484, -19.378]],
                    "c": true
                  }]
                }],
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.945098099054, 0.968627510819, 0.909803981407, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [35.027, 23.523],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 90,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 5,
          "ty": 4,
          "nm": "kurome 2",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [{
                "i": {
                  "x": 0.667,
                  "y": 1
                },
                "o": {
                  "x": 0.333,
                  "y": 0
                },
                "t": 0,
                "s": [38.116, 44.204, 0],
                "to": [0, 0, 0],
                "ti": [0, 0, 0]
              }, {
                "i": {
                  "x": 0.667,
                  "y": 0.667
                },
                "o": {
                  "x": 0.333,
                  "y": 0.333
                },
                "t": 10,
                "s": [63.116, 44.204, 0],
                "to": [0, 0, 0],
                "ti": [0, 0, 0]
              }, {
                "i": {
                  "x": 0.667,
                  "y": 1
                },
                "o": {
                  "x": 0.333,
                  "y": 0
                },
                "t": 50,
                "s": [63.116, 44.204, 0],
                "to": [0, 0, 0],
                "ti": [0, 0, 0]
              }, {
                "t": 60,
                "s": [38.116, 44.204, 0]
              }],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [20.385, 16.179, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0.014, 0.014], [-1.878, 0.029], [-0.825, 0.64], [-1.422, -0.227], [1.536, -1.891], [1.906, 0.484]],
                  "o": [[-1.806, -0.484], [0.938, -0.014], [1.663, -1.308], [1.422, 0.228], [-1.536, 1.891], [-0.014, 0]],
                  "v": [[-3.57, 3.285], [-3.1, -0.001], [-0.185, -0.839], [3.128, -3.555], [3.839, 1.408], [-3.512, 3.299]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.478431402468, 0.784313785329, 0.882353001015, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [26.514, 26.207],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-3.534, 0], [0, 1.971], [3.534, 0], [0, -1.971]],
                  "o": [[3.534, 0], [0, -1.971], [-3.534, 0], [0, 1.971]],
                  "v": [[0, 3.57], [6.399, 0.001], [0, -3.57], [-6.399, 0.001]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.996078491211, 0.996078491211, 0.992156922583, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [13.162, 20.135],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [13.088, 0], [0.88, -5.344], [0.002, -0.019], [0, 0], [-20.136, 0]],
                  "o": [[-0.734, -5.626], [-11.444, 0], [-0.004, 0.018], [-0.001, 0], [0, 0], [20.135, 0]],
                  "v": [[17.548, -2.074], [0.38, -15.929], [-17.1, -3.069], [-17.102, -3.012], [-17.107, -3.012], [0.001, 15.929]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.400000029919, 0.756862804936, 0.870588295133, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [20.385, 16.179],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 90,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 6,
          "ty": 4,
          "nm": "左まぶた影アウトライン",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [34.341, 53.597, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [14.446, 5.6, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [{
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 0,
                  "s": [{
                    "i": [[0, 0], [-6.77, 2.358], [-1.452, 0.452], [0, 0], [0, 0]],
                    "o": [[0, 0], [5.276, -1.838], [0, 0], [0, 0], [0, 0]],
                    "v": [[-14.749, -7.65], [-0.329, -13.199], [3.695, -14.963], [2.064, -17.85], [-15.445, -10.243]],
                    "c": true
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 10,
                  "s": [{
                    "i": [[0, 0], [-6.77, 2.358], [-1.452, 0.452], [0, 0], [0, 0]],
                    "o": [[0, 0], [5.276, -1.838], [0, 0], [0, 0], [0, 0]],
                    "v": [[-13.499, 5.35], [0.672, 0.926], [14.195, -4.463], [13.189, -6.85], [-14.195, 2.758]],
                    "c": true
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 50,
                  "s": [{
                    "i": [[0, 0], [-6.77, 2.358], [-1.452, 0.452], [0, 0], [0, 0]],
                    "o": [[0, 0], [5.276, -1.838], [0, 0], [0, 0], [0, 0]],
                    "v": [[-13.499, 5.35], [0.672, 0.926], [14.195, -4.463], [13.189, -6.85], [-14.195, 2.758]],
                    "c": true
                  }]
                }, {
                  "t": 60,
                  "s": [{
                    "i": [[0, 0], [-6.77, 2.358], [-1.452, 0.452], [0, 0], [0, 0]],
                    "o": [[0, 0], [5.276, -1.838], [0, 0], [0, 0], [0, 0]],
                    "v": [[-14.749, -7.65], [-0.329, -13.199], [3.695, -14.963], [2.064, -17.85], [-15.445, -10.243]],
                    "c": true
                  }]
                }],
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 1,
                "k": [{
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 0,
                  "s": [{
                    "i": [[0, 0], [-5.654, 0.203], [0.713, 0.366], [0, 0], [0, 0]],
                    "o": [[0, 0], [7.612, -0.273], [0, 0], [0, 0], [0, 0]],
                    "v": [[16.439, -17.775], [30.297, -19.324], [43.195, -19.463], [41.314, -23.35], [14.867, -21.493]],
                    "c": true
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 10,
                  "s": [{
                    "i": [[0, 0], [-5.17, 2.299], [0.713, 0.366], [0, 0], [0, 0]],
                    "o": [[0, 0], [6.237, -2.773], [0, 0], [0, 0], [0, 0]],
                    "v": [[22.252, -10.65], [32.297, -13.574], [43.195, -19.463], [41.314, -23.35], [23.93, -12.243]],
                    "c": true
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 50,
                  "s": [{
                    "i": [[0, 0], [-5.17, 2.299], [0.713, 0.366], [0, 0], [0, 0]],
                    "o": [[0, 0], [6.237, -2.773], [0, 0], [0, 0], [0, 0]],
                    "v": [[22.252, -10.65], [32.297, -13.574], [43.195, -19.463], [41.314, -23.35], [23.93, -12.243]],
                    "c": true
                  }]
                }, {
                  "t": 60,
                  "s": [{
                    "i": [[0, 0], [-5.654, 0.203], [0.713, 0.366], [0, 0], [0, 0]],
                    "o": [[0, 0], [7.612, -0.273], [0, 0], [0, 0], [0, 0]],
                    "v": [[16.439, -17.775], [30.297, -19.324], [43.195, -19.463], [41.314, -23.35], [14.867, -21.493]],
                    "c": true
                  }]
                }],
                "ix": 2
              },
              "nm": "パス 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [14.446, 5.6],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 90,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 7,
          "ty": 4,
          "nm": "sirome Lアウトライン",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [49.007, 56.419, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [32.778, 42.956, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [1.783, 3.898], [6.119, -0.649], [0.005, -1.043], [0, 0], [-1.038, 9.513], [0.54, 0.355], [0.199, -6.669], [-29.706, 0], [0.1, 16.324], [0.512, 3.1]],
                  "o": [[-0.286, 0.074], [-1.312, -2.868], [4.131, 9.899], [-0.204, 47.144], [-31.128, -2.532], [-0.725, -0.413], [-1.323, 4.749], [0, 0], [29.706, 0], [-0.014, -2.759], [0, 0]],
                  "v": [[31.689, -25.739], [27.707, -37.926], [24.862, -39.467], [29.131, -18.443], [-1.4, 22.042], [-26.314, -28.156], [-28.219, -29.307], [-30.609, -12.273], [-1.699, 24.701], [32.428, -16.851], [31.675, -25.725]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [32.778, 56.355],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [12.347, 8.565], [6.563, -3.003], [0, 0], [0.199, -6.669], [-29.706, 0], [0.1, 16.324], [0.512, 3.1]],
                  "o": [[0, 0], [-8.009, -3.56], [-14.906, 4.338], [-1.323, 4.749], [0, 0], [29.706, 0], [-0.014, -2.759], [0, 0]],
                  "v": [[31.128, -10.036], [15.125, -36.732], [-8.345, -37.4], [-28.781, -13.605], [-31.17, 3.43], [-2.261, 40.402], [31.867, -1.148], [31.114, -10.023]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 1, 1, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [33.34, 40.653],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 90,
          "st": 0,
          "bm": 0
        }]
      }],
      "layers": [{
        "ddd": 0,
        "ind": 1,
        "ty": 4,
        "nm": "汗アウトライン 2",
        "parent": 6,
        "sr": 1,
        "ks": {
          "o": {
            "a": 1,
            "k": [{
              "i": {
                "x": [0.667],
                "y": [1]
              },
              "o": {
                "x": [0.333],
                "y": [0]
              },
              "t": 34,
              "s": [100]
            }, {
              "t": 38,
              "s": [0]
            }],
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 1,
            "k": [{
              "i": {
                "x": 0.667,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 10,
              "s": [10.737, 0.054, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            }, {
              "t": 38,
              "s": [10.737, 5.054, 0]
            }],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [5.761, 0.485, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 1,
            "k": [{
              "i": {
                "x": [0.667, 0.667, 0.667],
                "y": [1, 1, 1]
              },
              "o": {
                "x": [0.333, 0.333, 0.333],
                "y": [0, 0, 0]
              },
              "t": 10,
              "s": [0, 0, 100]
            }, {
              "t": 19,
              "s": [100, 100, 100]
            }],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "shapes": [{
          "ty": "gr",
          "it": [{
            "ind": 0,
            "ty": "sh",
            "ix": 1,
            "ks": {
              "a": 0,
              "k": {
                "i": [[1.147, 3.886], [0.084, -0.335], [0.527, -3.575], [-4.013, 0.305], [0.508, 4.339]],
                "o": [[-0.097, -0.33], [-1.005, 4.012], [-0.558, 3.789], [4.012, -0.306], [-0.508, -4.338]],
                "v": [[-0.26, -12.905], [-0.831, -12.887], [-4.952, 4.904], [-0.01, 12.93], [5.003, 4.476]],
                "c": true
              },
              "ix": 2
            },
            "nm": "パス 1",
            "mn": "ADBE Vector Shape - Group",
            "hd": false
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1, 1],
              "ix": 4
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 5
            },
            "r": 1,
            "bm": 0,
            "nm": "塗り 1",
            "mn": "ADBE Vector Graphic - Fill",
            "hd": false
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [5.761, 13.485],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 3
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 6
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 7
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 4
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 5
            },
            "nm": "トランスフォーム"
          }],
          "nm": "グループ 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }],
        "ip": 0,
        "op": 90,
        "st": 0,
        "bm": 0
      }, {
        "ddd": 0,
        "ind": 2,
        "ty": 4,
        "nm": "汗アウトライン",
        "parent": 6,
        "sr": 1,
        "ks": {
          "o": {
            "a": 1,
            "k": [{
              "i": {
                "x": [0.667],
                "y": [1]
              },
              "o": {
                "x": [0.333],
                "y": [0]
              },
              "t": 34,
              "s": [100]
            }, {
              "t": 38,
              "s": [0]
            }],
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 1,
            "k": [{
              "i": {
                "x": 0.667,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 10,
              "s": [10.737, 0.054, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            }, {
              "t": 38,
              "s": [10.737, 5.054, 0]
            }],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [5.761, 0.485, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 1,
            "k": [{
              "i": {
                "x": [0.667, 0.667, 0.667],
                "y": [1, 1, 1]
              },
              "o": {
                "x": [0.333, 0.333, 0.333],
                "y": [0, 0, 0]
              },
              "t": 10,
              "s": [0, 0, 100]
            }, {
              "t": 19,
              "s": [100, 100, 100]
            }],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "shapes": [{
          "ty": "gr",
          "it": [{
            "ind": 0,
            "ty": "sh",
            "ix": 1,
            "ks": {
              "a": 0,
              "k": {
                "i": [[1.147, 3.886], [0.084, -0.335], [0.527, -3.575], [-4.013, 0.305], [0.508, 4.339]],
                "o": [[-0.097, -0.33], [-1.005, 4.012], [-0.558, 3.789], [4.012, -0.306], [-0.508, -4.338]],
                "v": [[-0.26, -12.905], [-0.831, -12.887], [-4.952, 4.904], [-0.01, 12.93], [5.003, 4.476]],
                "c": true
              },
              "ix": 2
            },
            "nm": "パス 1",
            "mn": "ADBE Vector Shape - Group",
            "hd": false
          }, {
            "ty": "st",
            "c": {
              "a": 0,
              "k": [0.243137269862, 0.701960784314, 0.847058883368, 1],
              "ix": 3
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 4
            },
            "w": {
              "a": 0,
              "k": 4,
              "ix": 5
            },
            "lc": 2,
            "lj": 2,
            "bm": 0,
            "nm": "線 1",
            "mn": "ADBE Vector Graphic - Stroke",
            "hd": false
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1, 1],
              "ix": 4
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 5
            },
            "r": 1,
            "bm": 0,
            "nm": "塗り 1",
            "mn": "ADBE Vector Graphic - Fill",
            "hd": false
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [5.761, 13.485],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 3
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 6
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 7
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 4
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 5
            },
            "nm": "トランスフォーム"
          }],
          "nm": "グループ 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }],
        "ip": 0,
        "op": 90,
        "st": 0,
        "bm": 0
      }, {
        "ddd": 0,
        "ind": 3,
        "ty": 0,
        "nm": "komaru_eye1",
        "parent": 6,
        "refId": "comp_0",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [85.404, 40.692, 0],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [101.5, 53, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100, 100],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "w": 203,
        "h": 106,
        "ip": 0,
        "op": 90,
        "st": 0,
        "bm": 0
      }, {
        "ddd": 0,
        "ind": 4,
        "ty": 0,
        "nm": "komaru_eye2",
        "parent": 6,
        "refId": "comp_1",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [85.404, 40.692, 0],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [101.5, 53, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100, 100],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "w": 203,
        "h": 106,
        "ip": 0,
        "op": 90,
        "st": 0,
        "bm": 0
      }, {
        "ddd": 0,
        "ind": 6,
        "ty": 3,
        "nm": "size web",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [84.846, 35.058, 0],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [85.25, 29.25, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100, 100],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "ip": 0,
        "op": 90,
        "st": 0,
        "bm": 0
      }],
      "markers": []
    };
    const params = {
      container: document.getElementById('js-lottie01'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      // path: this.getPath() + '404_komaru.json',
      animationData: animationData
    };
    let anim;
    anim = lottie.loadAnimation(params);
  }

  page_default() {
    console.log('default');
    this.img = $('#js-lottie');
    const tl = gsap.timeline({
      repeat: -1
    });
    let animationData01 = {
      "v": "5.9.2",
      "fr": 30,
      "ip": 0,
      "op": 30,
      "w": 172,
      "h": 58,
      "nm": "mabataki",
      "ddd": 0,
      "assets": [{
        "id": "comp_0",
        "nm": "mabataki_1eye",
        "fr": 30,
        "layers": [{
          "ddd": 0,
          "ind": 1,
          "ty": 4,
          "nm": "ふち",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [152.938, 54.557, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [38.68, 46.393, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [-22.328, 0], [-0.785, -4.322], [0, 0], [-0.014, -2.759], [31.441, 1.209], [0, 0], [-1.238, 4.631], [-0.05, 0.183]],
                  "o": [[1.252, -4.685], [23.02, 0], [0, 0], [0.512, 3.1], [0.099, 16.325], [-29.677, -1.137], [0.192, -6.413], [0.05, -0.185], [0, 0]],
                  "v": [[-28.576, -15.589], [1.72, -40.585], [30.992, -11.708], [31.099, -11.049], [31.854, -2.176], [-2.276, 39.376], [-31.184, 2.404], [-28.945, -14.081], [-28.796, -14.633]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [38.345, 46.977],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 30,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 2,
          "ty": 4,
          "nm": "7",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [153.755, 31.988, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.354, 18.477, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [{
                  "i": {
                    "x": 0.833,
                    "y": 0.833
                  },
                  "o": {
                    "x": 0.167,
                    "y": 0.167
                  },
                  "t": 3,
                  "s": [{
                    "i": [[0, 0], [13.978, 0], [2.375, 2.09]],
                    "o": [[0, 0], [-13.978, 0], [0, 0]],
                    "v": [[27.955, -5.66], [-0.817, -2.846], [-27.954, -8.904]],
                    "c": false
                  }]
                }, {
                  "t": 8,
                  "s": [{
                    "i": [[0, 0], [13.978, 0], [2.375, 2.09]],
                    "o": [[0, 0], [-13.978, 0], [0, 0]],
                    "v": [[29.954, -0.086], [-0.818, 3.654], [-29.954, -3.654]],
                    "c": false
                  }]
                }],
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.347, 30.653],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 3,
          "op": 32,
          "st": 7,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 3,
          "ty": 4,
          "nm": "mabuta kage",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [154.111, 29.838, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.361, 16.088, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[20.164, 1.038], [7.494, -26.918], [-0.1, -0.071], [-18.572, -0.625], [-3.925, -9.627], [-0.085, 0.014]],
                  "o": [[0, 0], [0.099, 0.057], [2.83, -6.783], [16.253, 0.555], [0.099, -0.029], [-2.218, -13.438]],
                  "v": [[-0.106, -14.157], [-29.954, 11.639], [-29.641, 11.837], [0.577, -10.844], [29.657, 15.279], [29.954, 15.208]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.874509803922, 0.933333333333, 0.894117647059, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.361, 15.53],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 30,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 4,
          "ty": 4,
          "nm": "8",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [153.755, 31.988, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.354, 18.477, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [{
                  "i": {
                    "x": 0.833,
                    "y": 0.833
                  },
                  "o": {
                    "x": 0.167,
                    "y": 0.167
                  },
                  "t": 3,
                  "s": [{
                    "i": [[-1.537, -9.769], [18.401, 0], [0, 0], [0, 0]],
                    "o": [[0, 0], [-18.401, 0], [7.122, -20.95], [20.164, 1.024]],
                    "v": [[27.788, 6.367], [-0.734, 10.107], [-27.621, 3.548], [-0.107, -15.998]],
                    "c": true
                  }]
                }, {
                  "t": 8,
                  "s": [{
                    "i": [[-2.218, -13.452], [18.401, 0], [0, 0], [0, 0]],
                    "o": [[0, 0], [-18.401, 0], [7.494, -26.905], [20.164, 1.024]],
                    "v": [[29.954, 13.367], [-0.818, 17.107], [-29.954, 9.798], [-0.107, -15.998]],
                    "c": true
                  }]
                }],
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.945098099054, 0.968627510819, 0.909803981407, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.347, 17.641],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 3,
          "op": 32,
          "st": 7,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 5,
          "ty": 4,
          "nm": "5",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [152.104, 82.1, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [31.252, 70.214, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [8.38, 0.11], [8.027, 2.101], [0.447, 0.187]],
                  "o": [[-6.659, 1.834], [-6.672, -0.087], [-0.515, -0.135], [0, 0]],
                  "v": [[31.145, -9.809], [1.45, -5.638], [-23.11, -8.951], [-29.772, -11.487]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [31.252, 67.464],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100.141, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-2.218, -13.452], [1.554, -10.737], [0, 0], [5.299, 0], [9.027, 4.258], [0.101, 1.494], [0, 0], [0, 0]],
                  "o": [[0, 0], [-1.554, 10.736], [0, 0], [-8.522, 0], [-0.92, -0.959], [-0.36, -5.313], [7.494, -26.905], [20.164, 1.024]],
                  "v": [[30.366, -5.753], [30.482, 15.637], [29.185, 21.219], [-0.031, 24.727], [-30.542, 19.312], [-31.676, 9.703], [-29.543, -9.322], [0.305, -33.743]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.945098099054, 0.968627510819, 0.909803981407, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [32.484, 36.761],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 6",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 6,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 2,
          "op": 3,
          "st": 1,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 6,
          "ty": 4,
          "nm": "3",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [152.104, 82.1, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [31.252, 70.214, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [8.381, 0], [5.547, 2.115], [0.447, 0.187]],
                  "o": [[-6.179, 1.077], [-9.071, 0], [-0.498, -0.189], [0, 0]],
                  "v": [[27.65, -0.184], [0.826, 2.612], [-22.361, -1.701], [-28.024, -3.987]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [31.252, 67.464],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100.141, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-2.218, -13.452], [1.554, -10.737], [0, 0], [5.299, 0], [9.027, 4.258], [0.101, 1.494], [0, 0], [0, 0]],
                  "o": [[0, 0], [-1.554, 10.736], [0, 0], [-8.522, 0], [-3.545, -6.209], [-0.36, -5.313], [7.494, -26.905], [20.164, 1.024]],
                  "v": [[30.366, -5.753], [30.482, 15.637], [26.56, 30.344], [-0.031, 33.727], [-28.292, 27.062], [-31.676, 9.703], [-29.543, -9.322], [0.305, -33.743]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.945098099054, 0.968627510819, 0.909803981407, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [32.484, 36.761],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 6",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 6,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-1.707, -0.32], [-11.849, 0.097], [0, 0], [0, 0], [0, 0]],
                  "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [2.211, 0.915], [0, 0], [10.958, -0.09], [0, 0], [0, 0], [0, 0]],
                  "v": [[18.572, -1.433], [1.701, -0.437], [-15.583, -2.219], [-16.256, -2.219], [-16.254, -2.258], [-25.861, -6.851], [-25.408, -3.888], [-17.603, -0.657], [1.789, 1.88], [19.052, 0.7], [26.704, -0.428], [28.236, -4.035]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.780392216701, 0.772549079446, 0.776470648074, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [30.928, 71.175],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 7",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 7,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 1,
          "op": 2,
          "st": 1,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 7,
          "ty": 4,
          "nm": "0",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [153.755, 31.988, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.354, 18.477, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[20.164, 1.038], [7.494, -26.918], [-0.1, -0.071], [-18.572, -0.625], [-3.925, -9.627], [-0.085, 0.014]],
                  "o": [[0, 0], [0.099, 0.057], [2.83, -6.783], [16.253, 0.555], [0.099, -0.029], [-2.218, -13.438]],
                  "v": [[-0.106, -14.157], [-29.954, 11.639], [-29.641, 11.837], [0.577, -10.844], [29.657, 15.279], [29.954, 15.208]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980451995, 0.933333393172, 0.89019613827, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.361, 15.53],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [13.978, 0], [2.375, 2.09]],
                  "o": [[0, 0], [-13.978, 0], [0, 0]],
                  "v": [[29.954, -0.086], [-0.818, 3.654], [-29.954, -3.654]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.347, 30.653],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-2.218, -13.452], [18.401, 0], [0, 0], [0, 0]],
                  "o": [[0, 0], [-18.401, 0], [7.494, -26.905], [20.164, 1.024]],
                  "v": [[29.954, 13.367], [-0.818, 17.107], [-29.954, 9.798], [-0.107, -15.998]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.945098099054, 0.968627510819, 0.909803981407, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.347, 17.641],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 1,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 8,
          "ty": 4,
          "nm": "base",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [{
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 2,
                "s": [153.124, 48.712, 0],
                "to": [0, 0, 0],
                "ti": [0, 0, 0]
              }, {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 3,
                "s": [153.124, 49.712, 0],
                "to": [0, 0, 0],
                "ti": [0, 0, 0]
              }, {
                "t": 4,
                "s": [153.124, 48.712, 0]
              }],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [20.579, 16.179, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0.014, 0.014], [-1.878, 0.029], [-0.825, 0.64], [-1.422, -0.227], [1.536, -1.891], [1.906, 0.484]],
                  "o": [[-1.806, -0.484], [0.938, -0.014], [1.663, -1.308], [1.422, 0.228], [-1.536, 1.891], [-0.014, 0]],
                  "v": [[-3.569, 3.285], [-3.1, -0.001], [-0.184, -0.839], [3.129, -3.555], [3.84, 1.408], [-3.512, 3.299]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.478431402468, 0.784313785329, 0.882353001015, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [26.514, 26.207],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-3.534, 0], [0, 1.971], [3.534, 0], [0, -1.971]],
                  "o": [[3.534, 0], [0, -1.971], [-3.534, 0], [0, 1.971]],
                  "v": [[0, 3.569], [6.399, 0], [0, -3.569], [-6.399, 0]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.996078491211, 0.996078491211, 0.992156922583, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [13.162, 20.135],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [13.088, 0], [0.88, -5.344], [0.002, -0.019], [0, 0], [-20.136, 0]],
                  "o": [[-0.734, -5.626], [-11.444, 0], [-0.004, 0.018], [-0.001, 0], [0, 0], [20.135, 0]],
                  "v": [[17.548, -2.074], [0.38, -15.929], [-17.1, -3.069], [-17.102, -3.012], [-17.107, -3.012], [0, 15.929]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.400000029919, 0.756862804936, 0.870588295133, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [20.385, 16.179],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 30,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 9,
          "ty": 4,
          "nm": "9",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [153.755, 33.488, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.354, 18.477, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-2.218, -13.452], [18.401, 0], [0, 0], [0, 0]],
                  "o": [[0, 0], [-18.401, 0], [7.494, -26.905], [20.164, 1.024]],
                  "v": [[29.954, 13.367], [-0.818, 17.107], [-29.954, 9.798], [-0.107, -15.998]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.347, 17.641],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "tm",
            "s": {
              "a": 0,
              "k": 0,
              "ix": 1
            },
            "e": {
              "a": 0,
              "k": 42,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 0,
              "ix": 3
            },
            "m": 1,
            "ix": 6,
            "nm": "パスのトリミング 1",
            "mn": "ADBE Vector Filter - Trim",
            "hd": false
          }],
          "ip": 0,
          "op": 1,
          "st": 4,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 10,
          "ty": 4,
          "nm": "6",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [153.755, 33.488, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.354, 18.477, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [{
                  "i": {
                    "x": 0.833,
                    "y": 0.833
                  },
                  "o": {
                    "x": 0.167,
                    "y": 0.167
                  },
                  "t": 3,
                  "s": [{
                    "i": [[-1.537, -9.769], [18.401, 0], [0, 0], [0, 0]],
                    "o": [[0, 0], [-18.401, 0], [7.122, -20.95], [20.164, 1.024]],
                    "v": [[27.788, 6.367], [-0.734, 10.107], [-27.621, 3.548], [-0.107, -15.998]],
                    "c": true
                  }]
                }, {
                  "t": 8,
                  "s": [{
                    "i": [[-2.218, -13.452], [18.401, 0], [0, 0], [0, 0]],
                    "o": [[0, 0], [-18.401, 0], [7.494, -26.905], [20.164, 1.024]],
                    "v": [[29.954, 13.367], [-0.818, 17.107], [-29.954, 9.798], [-0.107, -15.998]],
                    "c": true
                  }]
                }],
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.347, 17.641],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "tm",
            "s": {
              "a": 0,
              "k": 0,
              "ix": 1
            },
            "e": {
              "a": 1,
              "k": [{
                "i": {
                  "x": [0.833],
                  "y": [0.833]
                },
                "o": {
                  "x": [0.167],
                  "y": [0.167]
                },
                "t": 3,
                "s": [43]
              }, {
                "t": 8,
                "s": [42]
              }],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 0,
              "ix": 3
            },
            "m": 1,
            "ix": 6,
            "nm": "パスのトリミング 1",
            "mn": "ADBE Vector Filter - Trim",
            "hd": false
          }],
          "ip": 3,
          "op": 32,
          "st": 7,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 11,
          "ty": 4,
          "nm": "sirome",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [152.923, 54.544, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [33.688, 41.081, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[9.858, 1.082], [6.476, -3.544], [1.433, -2.26], [1.036, -3.212], [0, 0], [0, 0], [-3.607, 3.366], [-8.536, 0], [-2.044, -3.125], [0, 0], [0, 0], [2.314, 8.138], [1.923, 2.464]],
                  "o": [[-4.983, -0.547], [-4.304, 2.355], [-2.765, 4.364], [-0.777, 2.409], [0, 0], [0, 0], [3.607, -3.366], [8.536, 0], [2.044, 3.126], [0, 0], [0, 0], [-1.008, -3.544], [-3.848, -4.93]],
                  "v": [[2.807, -15.177], [-13.31, -11.39], [-22.004, -2.437], [-27.605, 9.823], [-28.857, 17.942], [-29.947, 7.998], [-21.6, -8.685], [1.363, -17.942], [24.087, -5.319], [29.947, 11.581], [27.352, 17.848], [25.419, 5.848], [20.72, -4.236]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [34.521, 19.049],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [0.981, -0.227], [0, 0], [-1.038, 9.513], [0.54, 0.355], [0.199, -6.669], [-29.706, 0], [0.1, 16.324], [0.512, 3.1]],
                  "o": [[-0.825, 0.213], [2.716, 54.378], [-31.128, -2.532], [-0.725, -0.413], [-1.323, 4.749], [0, 0], [29.706, 0], [-0.014, -2.759], [0, 0]],
                  "v": [[31.69, -25.739], [28.974, -25.07], [-1.401, 22.042], [-26.314, -28.156], [-28.219, -29.307], [-30.609, -12.273], [-1.7, 24.701], [32.429, -16.851], [31.676, -25.725]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [32.778, 56.355],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [12.347, 8.565], [6.563, -3.003], [0, 0], [0.199, -6.669], [-29.706, 0], [0.1, 16.324], [0.512, 3.1]],
                  "o": [[0, 0], [-8.009, -3.56], [-14.906, 4.338], [-1.323, 4.749], [0, 0], [29.706, 0], [-0.014, -2.759], [0, 0]],
                  "v": [[31.128, -10.036], [15.125, -36.732], [-8.345, -37.4], [-28.781, -13.605], [-31.17, 3.43], [-2.261, 40.402], [31.867, -1.148], [31.114, -10.023]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 1, 1, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [33.34, 40.653],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 30,
          "st": 0,
          "bm": 0
        }]
      }],
      "layers": [{
        "ddd": 0,
        "ind": 1,
        "ty": 0,
        "nm": "mabataki_1eye",
        "parent": 5,
        "refId": "comp_0",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [-17.596, 40.692, 0],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [101.5, 53, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100, 100],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "w": 203,
        "h": 106,
        "ip": 0,
        "op": 30,
        "st": 0,
        "bm": 0
      }, {
        "ddd": 0,
        "ind": 2,
        "ty": 0,
        "nm": "mabataki_1eye",
        "parent": 5,
        "refId": "comp_0",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [85.404, 40.692, 0],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [101.5, 53, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100, 100],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "w": 203,
        "h": 106,
        "ip": 0,
        "op": 30,
        "st": 0,
        "bm": 0
      }, {
        "ddd": 0,
        "ind": 5,
        "ty": 3,
        "nm": "size web",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [85.846, 29.558, 0],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [85.25, 29.25, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100, 100],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "ip": 0,
        "op": 30,
        "st": 0,
        "bm": 0
      }],
      "markers": []
    };
    let animationData02 = {
      "v": "5.9.2",
      "fr": 30,
      "ip": 0,
      "op": 150,
      "w": 172,
      "h": 58,
      "nm": "erabu",
      "ddd": 0,
      "assets": [{
        "id": "comp_0",
        "nm": "erabu_1eye",
        "fr": 30,
        "layers": [{
          "ddd": 0,
          "ind": 1,
          "ty": 4,
          "nm": "ふち 3",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [152.938, 54.557, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [38.68, 46.393, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [-22.328, 0], [-0.785, -4.322], [0, 0], [-0.014, -2.759], [31.441, 1.209], [0, 0], [-1.238, 4.631], [-0.05, 0.183]],
                  "o": [[1.252, -4.685], [23.02, 0], [0, 0], [0.512, 3.1], [0.099, 16.325], [-29.677, -1.137], [0.192, -6.413], [0.05, -0.185], [0, 0]],
                  "v": [[-28.576, -15.589], [1.72, -40.585], [30.992, -11.708], [31.099, -11.049], [31.854, -2.176], [-2.276, 39.376], [-31.184, 2.404], [-28.945, -14.081], [-28.796, -14.633]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215701234, 0.701960784314, 0.847058883368, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [38.345, 46.977],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 159,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 2,
          "ty": 4,
          "nm": "4",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [153.855, 31.569, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.454, 18.057, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [{
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 0,
                  "s": [{
                    "i": [[-2.218, -13.452], [18.401, 0], [0, 0], [0, 0]],
                    "o": [[0, 0], [-18.401, 0], [7.494, -26.905], [20.164, 1.024]],
                    "v": [[29.954, 13.367], [-0.818, 17.107], [-29.954, 9.798], [-0.107, -15.998]],
                    "c": true
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 4,
                  "s": [{
                    "i": [[-2.218, -13.452], [26.36, 0.866], [0, 0], [0, 0]],
                    "o": [[0, 0], [-24.517, -0.805], [7.494, -26.905], [20.164, 1.024]],
                    "v": [[29.954, 13.367], [0.141, -11.768], [-29.954, 9.798], [-0.107, -15.998]],
                    "c": true
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 139,
                  "s": [{
                    "i": [[-2.218, -13.452], [26.36, 0.866], [0, 0], [0, 0]],
                    "o": [[0, 0], [-24.517, -0.805], [7.494, -26.905], [20.164, 1.024]],
                    "v": [[29.954, 13.367], [0.141, -11.768], [-29.954, 9.798], [-0.107, -15.998]],
                    "c": true
                  }]
                }, {
                  "t": 149,
                  "s": [{
                    "i": [[-2.218, -13.452], [18.401, 0], [0, 0], [0, 0]],
                    "o": [[0, 0], [-18.401, 0], [7.494, -26.905], [20.164, 1.024]],
                    "v": [[29.954, 13.367], [-0.818, 17.107], [-29.954, 9.798], [-0.107, -15.998]],
                    "c": true
                  }]
                }],
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "tm",
              "s": {
                "a": 0,
                "k": 0,
                "ix": 1
              },
              "e": {
                "a": 1,
                "k": [{
                  "i": {
                    "x": [0.667],
                    "y": [2.071]
                  },
                  "o": {
                    "x": [0.333],
                    "y": [0]
                  },
                  "t": 0,
                  "s": [41]
                }, {
                  "i": {
                    "x": [0.667],
                    "y": [0.523]
                  },
                  "o": {
                    "x": [0.333],
                    "y": [0.278]
                  },
                  "t": 1,
                  "s": [40.3]
                }, {
                  "i": {
                    "x": [0.667],
                    "y": [1]
                  },
                  "o": {
                    "x": [0.333],
                    "y": [0.43]
                  },
                  "t": 2,
                  "s": [43]
                }, {
                  "i": {
                    "x": [0.833],
                    "y": [1]
                  },
                  "o": {
                    "x": [0.333],
                    "y": [0]
                  },
                  "t": 4,
                  "s": [49]
                }, {
                  "i": {
                    "x": [0.598],
                    "y": [0.725]
                  },
                  "o": {
                    "x": [0.173],
                    "y": [0]
                  },
                  "t": 139,
                  "s": [49]
                }, {
                  "i": {
                    "x": [0.697],
                    "y": [1]
                  },
                  "o": {
                    "x": [0.352],
                    "y": [-2.166]
                  },
                  "t": 146,
                  "s": [40.6]
                }, {
                  "t": 149,
                  "s": [41]
                }],
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 0,
                "ix": 3
              },
              "m": 1,
              "ix": 2,
              "nm": "パスのトリミング 1",
              "mn": "ADBE Vector Filter - Trim",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.5,
                "ix": 5
              },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.347, 17.641],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 167,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 3,
          "ty": 4,
          "nm": "5",
          "td": 1,
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [153.855, 31.569, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.454, 18.057, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [{
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 0,
                  "s": [{
                    "i": [[-2.218, -13.452], [18.401, 0], [0, 0], [0, 0]],
                    "o": [[0, 0], [-18.401, 0], [7.494, -26.905], [20.164, 1.024]],
                    "v": [[29.954, 13.367], [-0.818, 17.107], [-29.954, 9.798], [-0.107, -15.998]],
                    "c": true
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 4,
                  "s": [{
                    "i": [[-2.218, -13.452], [26.36, 0.866], [0, 0], [0, 0]],
                    "o": [[0, 0], [-24.517, -0.805], [7.494, -26.905], [20.164, 1.024]],
                    "v": [[29.954, 13.367], [0.141, -11.768], [-29.954, 9.798], [-0.107, -15.998]],
                    "c": true
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 139,
                  "s": [{
                    "i": [[-2.218, -13.452], [26.36, 0.866], [0, 0], [0, 0]],
                    "o": [[0, 0], [-24.517, -0.805], [7.494, -26.905], [20.164, 1.024]],
                    "v": [[29.954, 13.367], [0.141, -11.768], [-29.954, 9.798], [-0.107, -15.998]],
                    "c": true
                  }]
                }, {
                  "t": 149,
                  "s": [{
                    "i": [[-2.218, -13.452], [18.401, 0], [0, 0], [0, 0]],
                    "o": [[0, 0], [-18.401, 0], [7.494, -26.905], [20.164, 1.024]],
                    "v": [[29.954, 13.367], [-0.818, 17.107], [-29.954, 9.798], [-0.107, -15.998]],
                    "c": true
                  }]
                }],
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.945098099054, 0.968627510819, 0.909803981407, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.347, 17.641],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 167,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 4,
          "ty": 4,
          "nm": "mabuta kage",
          "tt": 1,
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [154.111, 29.838, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.361, 16.088, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[20.164, 1.038], [7.494, -26.918], [-0.1, -0.071], [-18.572, -0.625], [-3.925, -9.627], [-0.085, 0.014]],
                  "o": [[0, 0], [0.099, 0.057], [2.83, -6.783], [16.253, 0.555], [0.099, -0.029], [-2.218, -13.438]],
                  "v": [[-0.106, -14.157], [-29.954, 11.639], [-29.641, 11.837], [0.577, -10.844], [29.657, 15.279], [29.954, 15.208]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.874509803922, 0.933333333333, 0.894117647059, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.361, 15.53],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 154,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 5,
          "ty": 4,
          "nm": "2",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [153.855, 31.569, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.454, 18.057, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [{
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 0,
                  "s": [{
                    "i": [[-2.218, -13.452], [18.401, 0], [0, 0], [0, 0]],
                    "o": [[0, 0], [-18.401, 0], [7.494, -26.905], [20.164, 1.024]],
                    "v": [[29.954, 13.367], [-0.818, 17.107], [-29.954, 9.798], [-0.107, -15.998]],
                    "c": true
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 4,
                  "s": [{
                    "i": [[-2.218, -13.452], [26.36, 0.866], [0, 0], [0, 0]],
                    "o": [[0, 0], [-24.517, -0.805], [7.494, -26.905], [20.164, 1.024]],
                    "v": [[29.954, 13.367], [0.141, -11.768], [-29.954, 9.798], [-0.107, -15.998]],
                    "c": true
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 139,
                  "s": [{
                    "i": [[-2.218, -13.452], [26.36, 0.866], [0, 0], [0, 0]],
                    "o": [[0, 0], [-24.517, -0.805], [7.494, -26.905], [20.164, 1.024]],
                    "v": [[29.954, 13.367], [0.141, -11.768], [-29.954, 9.798], [-0.107, -15.998]],
                    "c": true
                  }]
                }, {
                  "t": 149,
                  "s": [{
                    "i": [[-2.218, -13.452], [18.401, 0], [0, 0], [0, 0]],
                    "o": [[0, 0], [-18.401, 0], [7.494, -26.905], [20.164, 1.024]],
                    "v": [[29.954, 13.367], [-0.818, 17.107], [-29.954, 9.798], [-0.107, -15.998]],
                    "c": true
                  }]
                }],
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.945098099054, 0.968627510819, 0.909803981407, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.347, 17.641],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 167,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 6,
          "ty": 4,
          "nm": "sirome 2",
          "td": 1,
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [152.923, 54.544, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [33.688, 41.081, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[9.858, 1.082], [6.476, -3.544], [1.433, -2.26], [1.036, -3.212], [0, 0], [0, 0], [-3.607, 3.366], [-8.536, 0], [-2.044, -3.125], [0, 0], [0, 0], [2.314, 8.138], [1.923, 2.464]],
                  "o": [[-4.983, -0.547], [-4.304, 2.355], [-2.765, 4.364], [-0.777, 2.409], [0, 0], [0, 0], [3.607, -3.366], [8.536, 0], [2.044, 3.126], [0, 0], [0, 0], [-1.008, -3.544], [-3.848, -4.93]],
                  "v": [[2.807, -15.177], [-13.31, -11.39], [-22.004, -2.437], [-27.605, 9.823], [-28.857, 17.942], [-29.947, 7.998], [-21.6, -8.685], [1.363, -17.942], [24.087, -5.319], [29.947, 11.581], [27.352, 17.848], [25.419, 5.848], [20.72, -4.236]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.780392216701, 0.772549079446, 0.776470648074, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [34.521, 19.049],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [0.981, -0.227], [0, 0], [-1.038, 9.513], [0.54, 0.355], [0.199, -6.669], [-29.706, 0], [0.1, 16.324], [0.512, 3.1]],
                  "o": [[-0.825, 0.213], [2.716, 54.378], [-31.128, -2.532], [-0.725, -0.413], [-1.323, 4.749], [0, 0], [29.706, 0], [-0.014, -2.759], [0, 0]],
                  "v": [[31.69, -25.739], [28.974, -25.07], [-1.401, 22.042], [-26.314, -28.156], [-28.219, -29.307], [-30.609, -12.273], [-1.7, 24.701], [32.429, -16.851], [31.676, -25.725]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.780392216701, 0.772549079446, 0.776470648074, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [32.778, 56.355],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [12.347, 8.565], [6.563, -3.003], [0, 0], [0.199, -6.669], [-29.706, 0], [0.1, 16.324], [0.512, 3.1]],
                  "o": [[0, 0], [-8.009, -3.56], [-14.906, 4.338], [-1.323, 4.749], [0, 0], [29.706, 0], [-0.014, -2.759], [0, 0]],
                  "v": [[31.128, -10.036], [15.125, -36.732], [-8.345, -37.4], [-28.781, -13.605], [-31.17, 3.43], [-2.261, 40.402], [31.867, -1.148], [31.114, -10.023]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 1, 1, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [33.34, 40.653],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 159,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 7,
          "ty": 4,
          "nm": "kurome",
          "tt": 1,
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [{
                "i": {
                  "x": 0.667,
                  "y": 1
                },
                "o": {
                  "x": 0.333,
                  "y": 0
                },
                "t": 0,
                "s": [153.124, 48.712, 0],
                "to": [0, 0, 0],
                "ti": [0, 0, 0]
              }, {
                "i": {
                  "x": 0.667,
                  "y": 0.667
                },
                "o": {
                  "x": 0.333,
                  "y": 0.333
                },
                "t": 4,
                "s": [153.124, 27.712, 0],
                "to": [0, 0, 0],
                "ti": [0, 0, 0]
              }, {
                "i": {
                  "x": 0.667,
                  "y": 1
                },
                "o": {
                  "x": 0.333,
                  "y": 0
                },
                "t": 41,
                "s": [153.124, 27.712, 0],
                "to": [0, 0, 0],
                "ti": [0, 0, 0]
              }, {
                "i": {
                  "x": 0.667,
                  "y": 0.667
                },
                "o": {
                  "x": 0.333,
                  "y": 0.333
                },
                "t": 51,
                "s": [144.624, 33.712, 0],
                "to": [0, 0, 0],
                "ti": [0, 0, 0]
              }, {
                "i": {
                  "x": 0.667,
                  "y": 1
                },
                "o": {
                  "x": 0.333,
                  "y": 0
                },
                "t": 94,
                "s": [144.624, 33.712, 0],
                "to": [0, 0, 0],
                "ti": [0, 0, 0]
              }, {
                "i": {
                  "x": 0.667,
                  "y": 0.667
                },
                "o": {
                  "x": 0.333,
                  "y": 0.333
                },
                "t": 105,
                "s": [163.624, 33.712, 0],
                "to": [0, 0, 0],
                "ti": [0, 0, 0]
              }, {
                "i": {
                  "x": 0.667,
                  "y": 1
                },
                "o": {
                  "x": 0.333,
                  "y": 0
                },
                "t": 139,
                "s": [163.624, 33.712, 0],
                "to": [0, 0, 0],
                "ti": [0, 0, 0]
              }, {
                "t": 149,
                "s": [153.124, 48.712, 0]
              }],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [20.579, 16.179, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0.014, 0.014], [-1.878, 0.029], [-0.825, 0.64], [-1.422, -0.227], [1.536, -1.891], [1.906, 0.484]],
                  "o": [[-1.806, -0.484], [0.938, -0.014], [1.663, -1.308], [1.422, 0.228], [-1.536, 1.891], [-0.014, 0]],
                  "v": [[-3.569, 3.285], [-3.1, -0.001], [-0.184, -0.839], [3.129, -3.555], [3.84, 1.408], [-3.512, 3.299]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.478431402468, 0.784313785329, 0.882353001015, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [26.514, 26.207],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-3.534, 0], [0, 1.971], [3.534, 0], [0, -1.971]],
                  "o": [[3.534, 0], [0, -1.971], [-3.534, 0], [0, 1.971]],
                  "v": [[0, 3.569], [6.399, 0], [0, -3.569], [-6.399, 0]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.996078491211, 0.996078491211, 0.992156922583, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [13.162, 20.135],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [13.088, 0], [0.88, -5.344], [0.002, -0.019], [0, 0], [-20.136, 0]],
                  "o": [[-0.734, -5.626], [-11.444, 0], [-0.004, 0.018], [-0.001, 0], [0, 0], [20.135, 0]],
                  "v": [[17.548, -2.074], [0.38, -15.929], [-17.1, -3.069], [-17.102, -3.012], [-17.107, -3.012], [0, 15.929]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.400000029919, 0.756862804936, 0.870588295133, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [20.385, 16.179],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 159,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 8,
          "ty": 4,
          "nm": "6",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [153.855, 33.569, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.454, 18.057, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [{
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 0,
                  "s": [{
                    "i": [[-2.218, -13.452], [18.401, 0], [0, 0], [0, 0]],
                    "o": [[0, 0], [-18.401, 0], [7.494, -26.905], [20.164, 1.024]],
                    "v": [[29.954, 13.367], [-0.818, 17.107], [-29.954, 9.798], [-0.107, -15.998]],
                    "c": true
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 4,
                  "s": [{
                    "i": [[-2.218, -13.452], [26.36, 0.866], [0, 0], [0, 0]],
                    "o": [[0, 0], [-24.517, -0.805], [7.494, -26.905], [20.164, 1.024]],
                    "v": [[29.954, 13.367], [0.141, -11.768], [-29.954, 9.798], [-0.107, -15.998]],
                    "c": true
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 139,
                  "s": [{
                    "i": [[-2.218, -13.452], [26.36, 0.866], [0, 0], [0, 0]],
                    "o": [[0, 0], [-24.517, -0.805], [7.494, -26.905], [20.164, 1.024]],
                    "v": [[29.954, 13.367], [0.141, -11.768], [-29.954, 9.798], [-0.107, -15.998]],
                    "c": true
                  }]
                }, {
                  "t": 149,
                  "s": [{
                    "i": [[-2.218, -13.452], [18.401, 0], [0, 0], [0, 0]],
                    "o": [[0, 0], [-18.401, 0], [7.494, -26.905], [20.164, 1.024]],
                    "v": [[29.954, 13.367], [-0.818, 17.107], [-29.954, 9.798], [-0.107, -15.998]],
                    "c": true
                  }]
                }],
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "tm",
              "s": {
                "a": 0,
                "k": 0,
                "ix": 1
              },
              "e": {
                "a": 1,
                "k": [{
                  "i": {
                    "x": [0.667],
                    "y": [2.071]
                  },
                  "o": {
                    "x": [0.333],
                    "y": [0]
                  },
                  "t": 0,
                  "s": [41]
                }, {
                  "i": {
                    "x": [0.667],
                    "y": [0.523]
                  },
                  "o": {
                    "x": [0.333],
                    "y": [0.278]
                  },
                  "t": 1,
                  "s": [40.3]
                }, {
                  "i": {
                    "x": [0.667],
                    "y": [1]
                  },
                  "o": {
                    "x": [0.333],
                    "y": [0.43]
                  },
                  "t": 2,
                  "s": [43]
                }, {
                  "i": {
                    "x": [0.833],
                    "y": [1]
                  },
                  "o": {
                    "x": [0.333],
                    "y": [0]
                  },
                  "t": 4,
                  "s": [49]
                }, {
                  "i": {
                    "x": [0.598],
                    "y": [0.725]
                  },
                  "o": {
                    "x": [0.173],
                    "y": [0]
                  },
                  "t": 139,
                  "s": [49]
                }, {
                  "i": {
                    "x": [0.697],
                    "y": [1]
                  },
                  "o": {
                    "x": [0.352],
                    "y": [-2.166]
                  },
                  "t": 146,
                  "s": [40.6]
                }, {
                  "t": 149,
                  "s": [41]
                }],
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 0,
                "ix": 3
              },
              "m": 1,
              "ix": 2,
              "nm": "パスのトリミング 1",
              "mn": "ADBE Vector Filter - Trim",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.5,
                "ix": 5
              },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.347, 17.641],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 167,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 11,
          "ty": 4,
          "nm": "sirome",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [152.923, 54.544, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [33.688, 41.081, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[9.858, 1.082], [6.476, -3.544], [1.433, -2.26], [1.08, -2.977], [0.475, -4.584], [0, 0], [0, 0], [-3.607, 3.366], [-8.536, 0], [-2.044, -3.125], [0, 0], [0, 0], [2.314, 8.138], [1.923, 2.464]],
                  "o": [[-4.983, -0.547], [-4.304, 2.355], [-2.204, 3.478], [-0.275, 0.759], [-0.261, 2.518], [0, 0], [0, 0], [3.607, -3.366], [8.536, 0], [2.044, 3.126], [0, 0], [0, 0], [-1.008, -3.544], [-3.848, -4.93]],
                  "v": [[2.807, -15.177], [-13.31, -11.39], [-22.004, -2.437], [-26.878, 7.699], [-29.168, 20.51], [-30.857, 17.567], [-29.947, 7.998], [-21.6, -8.685], [1.363, -17.942], [24.087, -5.319], [29.947, 11.581], [27.352, 17.848], [25.419, 5.848], [20.72, -4.236]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [34.521, 19.049],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [0.981, -0.227], [0, 0], [-0.501, 14.865], [-1.261, 4.151], [0.54, 0.355], [0.199, -6.669], [-29.706, 0], [0.1, 16.324], [0.512, 3.1]],
                  "o": [[-0.825, 0.213], [2.716, 54.378], [-23.566, -1.917], [0.161, -4.77], [-0.725, -0.413], [-1.323, 4.749], [0, 0], [29.706, 0], [-0.014, -2.759], [0, 0]],
                  "v": [[31.69, -25.739], [28.974, -25.07], [-1.401, 22.042], [-27.224, -17.072], [-25.127, -29.656], [-28.219, -29.307], [-30.609, -12.273], [-1.7, 24.701], [32.429, -16.851], [31.676, -25.725]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [32.778, 56.355],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [12.347, 8.565], [6.563, -3.003], [0, 0], [0.199, -6.669], [-29.706, 0], [0.1, 16.324], [0.512, 3.1]],
                  "o": [[0, 0], [-8.009, -3.56], [-14.906, 4.338], [-1.323, 4.749], [0, 0], [29.706, 0], [-0.014, -2.759], [0, 0]],
                  "v": [[31.128, -10.036], [15.125, -36.732], [-8.345, -37.4], [-28.781, -13.605], [-31.17, 3.43], [-2.261, 40.402], [31.867, -1.148], [31.114, -10.023]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 1, 1, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [33.34, 40.653],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 159,
          "st": 0,
          "bm": 0
        }]
      }],
      "layers": [{
        "ddd": 0,
        "ind": 1,
        "ty": 0,
        "nm": "erabu_1eye",
        "parent": 6,
        "refId": "comp_0",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [-17.596, 40.692, 0],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [101.5, 53, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100, 100],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "w": 203,
        "h": 106,
        "ip": 0,
        "op": 150,
        "st": 0,
        "bm": 0
      }, {
        "ddd": 0,
        "ind": 2,
        "ty": 0,
        "nm": "erabu_1eye",
        "parent": 6,
        "refId": "comp_0",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [85.404, 40.692, 0],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [101.5, 53, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100, 100],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "hasMask": true,
        "masksProperties": [{
          "inv": false,
          "mode": "n",
          "pt": {
            "a": 0,
            "k": {
              "i": [[0, 0]],
              "o": [[0, 0]],
              "v": [[1.5, 25.5]],
              "c": false
            },
            "ix": 1
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 3
          },
          "x": {
            "a": 0,
            "k": 0,
            "ix": 4
          },
          "nm": "マスク 1"
        }],
        "w": 203,
        "h": 106,
        "ip": 0,
        "op": 150,
        "st": 0,
        "bm": 0
      }, {
        "ddd": 0,
        "ind": 3,
        "ty": 4,
        "nm": "aoアウトライン",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [85.721, 42.058, 0],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [84.828, 41.529, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100, 100],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "shapes": [{
          "ty": "gr",
          "it": [{
            "ind": 0,
            "ty": "sh",
            "ix": 1,
            "ks": {
              "a": 0,
              "k": {
                "i": [[0.455, 2.877], [0, 0], [0.049, 0.277], [0, 0], [0, 0], [22.818, 0], [0.056, -0.269], [0, 0], [0.187, -6.276], [-30.58, -1.172], [-0.683, 0], [-5.499, 5.325], [0.064, 10.511]],
                "o": [[0, 0], [-0.003, -0.02], [0, 0], [0, 0], [-1.247, -5.98], [-25.982, 0], [0, 0], [-1.373, 5.04], [-0.008, 0.371], [0.703, 0.027], [9.645, -0.001], [9.605, -9.298], [-0.015, -2.89]],
                "v": [[32.272, -10.286], [32.22, -10.658], [32.142, -11.122], [31.988, -12.051], [31.962, -12.044], [1.574, -41.279], [-30.208, -14.304], [-30.253, -14.08], [-32.608, 2.961], [-2.47, 41.238], [-0.392, 41.279], [22.419, 33.262], [32.986, -1.598]],
                "c": true
              },
              "ix": 2
            },
            "nm": "パス 1",
            "mn": "ADBE Vector Shape - Group",
            "hd": false
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [0.239215701234, 0.701960784314, 0.847058883368, 1],
              "ix": 4
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 5
            },
            "r": 1,
            "bm": 0,
            "nm": "塗り 1",
            "mn": "ADBE Vector Graphic - Fill",
            "hd": false
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [136.356, 41.529],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 3
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 6
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 7
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 4
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 5
            },
            "nm": "トランスフォーム"
          }],
          "nm": "グループ 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }, {
          "ty": "gr",
          "it": [{
            "ind": 0,
            "ty": "sh",
            "ix": 1,
            "ks": {
              "a": 0,
              "k": {
                "i": [[0, 0], [0.058, 0.319], [0, 0], [0, 0], [22.817, 0], [0.054, -0.27], [0, 0], [0.187, -6.268], [-30.58, -1.172], [-0.682, 0], [-5.499, 5.323], [0.064, 10.51], [0.431, 2.798]],
                "o": [[-0.003, -0.022], [0, 0], [0, 0], [-1.247, -5.981], [-25.984, 0], [0, 0], [-1.372, 5.044], [-0.008, 0.371], [0.702, 0.027], [9.646, -0.001], [9.604, -9.3], [-0.015, -2.809], [0, 0]],
                "v": [[32.22, -10.657], [32.128, -11.197], [31.987, -12.052], [31.962, -12.045], [1.575, -41.279], [-30.208, -14.304], [-30.255, -14.075], [-32.609, 2.96], [-2.47, 41.238], [-0.393, 41.279], [22.42, 33.262], [32.986, -1.598], [32.306, -10.04]],
                "c": true
              },
              "ix": 2
            },
            "nm": "パス 1",
            "mn": "ADBE Vector Shape - Group",
            "hd": false
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [0.239215701234, 0.701960784314, 0.847058883368, 1],
              "ix": 4
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 5
            },
            "r": 1,
            "bm": 0,
            "nm": "塗り 1",
            "mn": "ADBE Vector Graphic - Fill",
            "hd": false
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [33.3, 41.529],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 3
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 6
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 7
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 4
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 5
            },
            "nm": "トランスフォーム"
          }],
          "nm": "グループ 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        }],
        "ip": 0,
        "op": 158,
        "st": 0,
        "bm": 0
      }, {
        "ddd": 0,
        "ind": 6,
        "ty": 3,
        "nm": "size webアウトライン",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [85.846, 29.558, 0],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [85.25, 29.25, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100, 100],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "ip": 0,
        "op": 30,
        "st": 0,
        "bm": 0
      }],
      "markers": []
    };
    let animationData03 = {
      "v": "5.9.2",
      "fr": 30,
      "ip": 0,
      "op": 120,
      "w": 172,
      "h": 58,
      "nm": "sorasu",
      "ddd": 0,
      "assets": [{
        "id": "comp_0",
        "nm": "komaru_parts",
        "fr": 30,
        "layers": [{
          "ddd": 0,
          "ind": 1,
          "ty": 0,
          "nm": "sorasu_1eye",
          "refId": "comp_1",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [-1.5, 53, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [101.5, 53, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "w": 203,
          "h": 106,
          "ip": 0,
          "op": 120,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 2,
          "ty": 0,
          "nm": "sorasu_1eye",
          "refId": "comp_1",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [101.5, 53, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [101.5, 53, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "w": 203,
          "h": 106,
          "ip": 0,
          "op": 120,
          "st": 0,
          "bm": 0
        }]
      }, {
        "id": "comp_1",
        "nm": "sorasu_1eye",
        "fr": 30,
        "layers": [{
          "ddd": 0,
          "ind": 1,
          "ty": 4,
          "nm": "ふち",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [152.603, 55.142, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [38.345, 46.977, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [-22.328, 0], [-0.785, -4.322], [0, 0], [-0.014, -2.759], [31.441, 1.209], [0, 0], [-1.238, 4.631], [-0.05, 0.183]],
                  "o": [[1.252, -4.685], [23.02, 0], [0, 0], [0.512, 3.1], [0.099, 16.325], [-29.677, -1.137], [0.192, -6.413], [0.05, -0.185], [0, 0]],
                  "v": [[-28.576, -15.589], [1.72, -40.585], [30.992, -11.708], [31.099, -11.049], [31.854, -2.176], [-2.276, 39.376], [-31.184, 2.404], [-28.945, -14.081], [-28.796, -14.633]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [38.345, 46.977],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 124,
          "st": 5,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 2,
          "ty": 4,
          "nm": "mabuta kage",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [154.111, 29.838, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.361, 16.088, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[20.164, 1.038], [7.494, -26.918], [-0.1, -0.071], [-18.572, -0.625], [-3.925, -9.627], [-0.085, 0.014]],
                  "o": [[0, 0], [0.099, 0.057], [2.83, -6.783], [16.253, 0.555], [0.099, -0.029], [-2.218, -13.438]],
                  "v": [[-0.106, -14.157], [-29.954, 11.639], [-29.641, 11.837], [0.577, -10.844], [29.657, 15.279], [29.954, 15.208]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.874509803922, 0.933333333333, 0.894117647059, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.361, 15.53],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 128,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 3,
          "ty": 4,
          "nm": "0",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [153.748, 33.861, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.347, 20.35, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [13.978, 0], [2.375, 2.09]],
                  "o": [[0, 0], [-13.978, 0], [0, 0]],
                  "v": [[29.954, -0.086], [-0.818, 3.654], [-29.954, -3.654]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.243137269862, 0.705882352941, 0.847058883368, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.347, 30.653],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-2.218, -13.452], [18.401, 0], [0, 0], [0, 0]],
                  "o": [[0, 0], [-18.401, 0], [7.494, -26.905], [20.164, 1.024]],
                  "v": [[29.954, 13.367], [-0.818, 17.107], [-29.954, 9.798], [-0.107, -15.998]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.945098099054, 0.968627510819, 0.909803981407, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.347, 17.641],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 6,
          "st": 5,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 4,
          "ty": 4,
          "nm": "4",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [153.748, 33.861, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.347, 20.35, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [{
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 6,
                  "s": [{
                    "i": [[0, 0], [13.978, 0], [2.375, 2.09]],
                    "o": [[0, 0], [-13.978, 0], [0, 0]],
                    "v": [[29.954, -0.086], [-0.818, 3.654], [-29.954, -3.654]],
                    "c": false
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 21,
                  "s": [{
                    "i": [[0, 0], [14.819, 1.682], [2.375, 2.09]],
                    "o": [[0, 0], [-13.889, -1.576], [0, 0]],
                    "v": [[30.454, 11.039], [-1.318, 8.904], [-30.579, 0.846]],
                    "c": false
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 85,
                  "s": [{
                    "i": [[0, 0], [14.819, 1.682], [2.375, 2.09]],
                    "o": [[0, 0], [-13.889, -1.576], [0, 0]],
                    "v": [[30.454, 11.039], [-1.318, 8.904], [-30.579, 0.846]],
                    "c": false
                  }]
                }, {
                  "t": 101,
                  "s": [{
                    "i": [[0, 0], [13.978, 0], [2.375, 2.09]],
                    "o": [[0, 0], [-13.978, 0], [0, 0]],
                    "v": [[29.954, -0.086], [-0.818, 3.654], [-29.954, -3.654]],
                    "c": false
                  }]
                }],
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.347, 30.653],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [{
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 6,
                  "s": [{
                    "i": [[-2.218, -13.452], [18.401, 0], [0, 0], [0, 0]],
                    "o": [[0, 0], [-18.401, 0], [7.494, -26.905], [20.164, 1.024]],
                    "v": [[29.954, 13.367], [-0.818, 17.107], [-29.954, 9.798], [-0.107, -15.998]],
                    "c": true
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 21,
                  "s": [{
                    "i": [[0.047, -21.769], [18.194, 1.241], [0, 0], [0, 0]],
                    "o": [[0, 0], [-18.358, -1.252], [5.956, -32.95], [20.164, 1.024]],
                    "v": [[30.579, 22.492], [-1.193, 21.107], [-30.704, 13.423], [-0.107, -15.998]],
                    "c": true
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 85,
                  "s": [{
                    "i": [[0.047, -21.769], [18.194, 1.241], [0, 0], [0, 0]],
                    "o": [[0, 0], [-18.358, -1.252], [5.956, -32.95], [20.164, 1.024]],
                    "v": [[30.579, 22.492], [-1.193, 21.107], [-30.704, 13.423], [-0.107, -15.998]],
                    "c": true
                  }]
                }, {
                  "t": 101,
                  "s": [{
                    "i": [[-2.218, -13.452], [18.401, 0], [0, 0], [0, 0]],
                    "o": [[0, 0], [-18.401, 0], [7.494, -26.905], [20.164, 1.024]],
                    "v": [[29.954, 13.367], [-0.818, 17.107], [-29.954, 9.798], [-0.107, -15.998]],
                    "c": true
                  }]
                }],
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.945098099054, 0.968627510819, 0.909803981407, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.347, 17.641],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 6,
          "op": 122,
          "st": 5,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 6,
          "ty": 4,
          "nm": "base",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [{
                "i": {
                  "x": 0.667,
                  "y": 1
                },
                "o": {
                  "x": 0.333,
                  "y": 0
                },
                "t": 5,
                "s": [152.93, 48.712, 0],
                "to": [0, 0, 0],
                "ti": [0, 0, 0]
              }, {
                "i": {
                  "x": 0.667,
                  "y": 0.667
                },
                "o": {
                  "x": 0.333,
                  "y": 0.333
                },
                "t": 20,
                "s": [167.18, 53.462, 0],
                "to": [0, 0, 0],
                "ti": [0, 0, 0]
              }, {
                "i": {
                  "x": 0.667,
                  "y": 1
                },
                "o": {
                  "x": 0.333,
                  "y": 0
                },
                "t": 84,
                "s": [167.18, 53.462, 0],
                "to": [0, 0, 0],
                "ti": [0, 0, 0]
              }, {
                "t": 100,
                "s": [152.93, 48.712, 0]
              }],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [20.385, 16.179, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0.014, 0.014], [-1.878, 0.029], [-0.825, 0.64], [-1.422, -0.227], [1.536, -1.891], [1.906, 0.484]],
                  "o": [[-1.806, -0.484], [0.938, -0.014], [1.663, -1.308], [1.422, 0.228], [-1.536, 1.891], [-0.014, 0]],
                  "v": [[-3.569, 3.285], [-3.1, -0.001], [-0.184, -0.839], [3.129, -3.555], [3.84, 1.408], [-3.512, 3.299]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.474509833841, 0.784313785329, 0.882353001015, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [26.514, 26.207],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-3.534, 0], [0, 1.971], [3.534, 0], [0, -1.971]],
                  "o": [[3.534, 0], [0, -1.971], [-3.534, 0], [0, 1.971]],
                  "v": [[0, 3.569], [6.399, 0], [0, -3.569], [-6.399, 0]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.996078491211, 0.996078491211, 0.992156922583, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [13.162, 20.135],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [13.088, 0], [0.88, -5.344], [0.002, -0.019], [0, 0], [-20.136, 0]],
                  "o": [[-0.734, -5.626], [-11.444, 0], [-0.004, 0.018], [-0.001, 0], [0, 0], [20.135, 0]],
                  "v": [[17.548, -2.074], [0.38, -15.929], [-17.1, -3.069], [-17.102, -3.012], [-17.107, -3.012], [0, 15.929]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.478431402468, 0.784313785329, 0.882353001015, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [20.385, 16.179],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 123,
          "st": 5,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 7,
          "ty": 4,
          "nm": "5",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [153.748, 35.486, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.347, 20.35, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [{
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 6,
                  "s": [{
                    "i": [[0, 0], [13.978, 0], [2.375, 2.09]],
                    "o": [[0, 0], [-13.978, 0], [0, 0]],
                    "v": [[29.954, -0.086], [-0.818, 3.654], [-29.954, -3.654]],
                    "c": false
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 21,
                  "s": [{
                    "i": [[0, 0], [14.819, 1.682], [2.375, 2.09]],
                    "o": [[0, 0], [-13.889, -1.576], [0, 0]],
                    "v": [[30.454, 11.039], [-1.318, 8.904], [-30.579, 0.846]],
                    "c": false
                  }]
                }, {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 85,
                  "s": [{
                    "i": [[0, 0], [14.819, 1.682], [2.375, 2.09]],
                    "o": [[0, 0], [-13.889, -1.576], [0, 0]],
                    "v": [[30.454, 11.039], [-1.318, 8.904], [-30.579, 0.846]],
                    "c": false
                  }]
                }, {
                  "t": 101,
                  "s": [{
                    "i": [[0, 0], [13.978, 0], [2.375, 2.09]],
                    "o": [[0, 0], [-13.978, 0], [0, 0]],
                    "v": [[29.954, -0.086], [-0.818, 3.654], [-29.954, -3.654]],
                    "c": false
                  }]
                }],
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.347, 30.653],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 122,
          "st": 5,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 8,
          "ty": 4,
          "nm": "sirome 2",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [152.923, 54.544, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [33.688, 41.081, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[9.858, 1.082], [6.476, -3.544], [1.433, -2.26], [1.036, -3.212], [0, 0], [0, 0], [-3.607, 3.366], [-8.536, 0], [-2.044, -3.125], [0, 0], [0, 0], [2.314, 8.138], [1.923, 2.464]],
                  "o": [[-4.983, -0.547], [-4.304, 2.355], [-2.765, 4.364], [-0.777, 2.409], [0, 0], [0, 0], [3.607, -3.366], [8.536, 0], [2.044, 3.126], [0, 0], [0, 0], [-1.008, -3.544], [-3.848, -4.93]],
                  "v": [[2.807, -15.177], [-13.31, -11.39], [-22.004, -2.437], [-27.605, 9.823], [-28.857, 17.942], [-29.947, 7.998], [-21.6, -8.685], [1.363, -17.942], [24.087, -5.319], [29.947, 11.581], [27.352, 17.848], [25.419, 5.848], [20.72, -4.236]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [34.521, 19.049],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [0.981, -0.227], [0, 0], [-1.038, 9.513], [0.54, 0.355], [0.199, -6.669], [-29.706, 0], [0.1, 16.324], [0.512, 3.1]],
                  "o": [[-0.825, 0.213], [2.716, 54.378], [-31.128, -2.532], [-0.725, -0.413], [-1.323, 4.749], [0, 0], [29.706, 0], [-0.014, -2.759], [0, 0]],
                  "v": [[31.69, -25.739], [28.974, -25.07], [-1.401, 22.042], [-26.314, -28.156], [-28.219, -29.307], [-30.609, -12.273], [-1.7, 24.701], [32.429, -16.851], [31.676, -25.725]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [32.778, 56.355],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [12.347, 8.565], [6.563, -3.003], [0, 0], [0.199, -6.669], [-29.706, 0], [0.1, 16.324], [0.512, 3.1]],
                  "o": [[0, 0], [-8.009, -3.56], [-14.906, 4.338], [-1.323, 4.749], [0, 0], [29.706, 0], [-0.014, -2.759], [0, 0]],
                  "v": [[31.128, -10.036], [15.125, -36.732], [-8.345, -37.4], [-28.781, -13.605], [-31.17, 3.43], [-2.261, 40.402], [31.867, -1.148], [31.114, -10.023]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 1, 1, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [33.34, 40.653],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 124,
          "st": 5,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 9,
          "ty": 4,
          "nm": "ao",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [152.939, 54.558, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [136.546, 41.529, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0.455, 2.877], [0, 0], [0.049, 0.277], [0, 0], [0, 0], [22.818, 0], [0.056, -0.269], [0, 0], [0.187, -6.276], [-30.58, -1.172], [-0.683, 0], [-5.499, 5.325], [0.064, 10.511]],
                  "o": [[0, 0], [-0.003, -0.02], [0, 0], [0, 0], [-1.247, -5.98], [-25.982, 0], [0, 0], [-1.373, 5.04], [-0.008, 0.371], [0.703, 0.027], [9.645, -0.001], [9.605, -9.298], [-0.015, -2.89]],
                  "v": [[32.272, -10.286], [32.22, -10.658], [32.142, -11.122], [31.988, -12.051], [31.962, -12.044], [1.574, -41.279], [-30.208, -14.304], [-30.253, -14.08], [-32.608, 2.961], [-2.47, 41.238], [-0.392, 41.279], [22.419, 33.262], [32.986, -1.598]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.239215701234, 0.701960784314, 0.847058883368, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [136.356, 41.529],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 124,
          "st": 5,
          "bm": 0
        }]
      }],
      "layers": [{
        "ddd": 0,
        "ind": 1,
        "ty": 0,
        "nm": "komaru_parts",
        "refId": "comp_0",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [86, 41, 0],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [101.5, 53, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100, 100],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "w": 203,
        "h": 106,
        "ip": 0,
        "op": 120,
        "st": 0,
        "bm": 0
      }],
      "markers": []
    };
    let animationData04 = {
      "v": "5.9.2",
      "fr": 30,
      "ip": 0,
      "op": 120,
      "w": 172,
      "h": 58,
      "nm": "kirakira",
      "ddd": 0,
      "assets": [{
        "id": "comp_0",
        "nm": "kirakira_parts",
        "fr": 30,
        "layers": [{
          "ddd": 0,
          "ind": 1,
          "ty": 4,
          "nm": "fuchi",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [152.603, 55.142, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [38.345, 46.977, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [-22.328, 0], [-0.785, -4.322], [0, 0], [-0.014, -2.759], [31.441, 1.209], [0, 0], [-1.238, 4.631], [-0.05, 0.183]],
                  "o": [[1.252, -4.685], [23.02, 0], [0, 0], [0.512, 3.1], [0.099, 16.325], [-29.677, -1.137], [0.192, -6.413], [0.05, -0.185], [0, 0]],
                  "v": [[-28.576, -15.589], [1.72, -40.585], [30.992, -11.708], [31.099, -11.049], [31.854, -2.176], [-2.276, 39.376], [-31.184, 2.404], [-28.945, -14.081], [-28.796, -14.633]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [38.345, 46.977],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 120,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 2,
          "ty": 4,
          "nm": "17",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [153.238, 53.121, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [32.385, 39.609, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [8.381, 0], [5.547, 2.115], [0.447, 0.187]],
                  "o": [[-6.179, 1.077], [-9.071, 0], [-0.498, -0.189], [0, 0]],
                  "v": [[24.779, 0.191], [0.826, 2.612], [-22.361, -1.701], [-24.779, -2.612]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [31.252, 70.214],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-2.218, -13.452], [1.554, -10.737], [0, 0], [5.299, 0], [9.027, 4.258], [0.101, 1.494], [0, 0], [0, 0]],
                  "o": [[0, 0], [-1.554, 10.736], [0, 0], [-8.522, 0], [-4.238, -7.911], [-0.36, -5.313], [7.494, -26.905], [20.164, 1.024]],
                  "v": [[30.366, -5.753], [30.482, 15.637], [23.56, 33.719], [-0.406, 36.227], [-26.167, 30.187], [-31.676, 9.703], [-29.543, -9.322], [0.305, -35.118]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.945098099054, 0.968627510819, 0.909803981407, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [32.484, 36.761],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 6",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 6,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-1.707, -0.32], [-11.849, 0.096], [0, 0], [0, 0], [0, 0]],
                  "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [2.211, 0.915], [0, 0], [10.958, -0.09], [0, 0], [0, 0], [0, 0]],
                  "v": [[18.572, 0.817], [1.701, 1.813], [-15.583, 0.031], [-16.256, 0.031], [-16.254, -0.008], [-24.611, -4.226], [-22.908, -0.638], [-16.353, 1.593], [1.789, 4.13], [18.802, 2.575], [22.829, 1.947], [24.611, -0.285]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [30.928, 71.175],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 7",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 7,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 29,
          "op": 30,
          "st": 29,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 3,
          "ty": 4,
          "nm": "16",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [152.525, 43.65, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [37.571, 30.139, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [13.978, 0], [5.431, 2.268], [0.696, 0.612]],
                  "o": [[0, 0], [-9.886, 0], [-2.249, -0.939], [0, 0]],
                  "v": [[31.178, 0.388], [0.406, 4.128], [-24.199, -0.75], [-31.178, -4.128]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [37.571, 49.757],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[20.164, 1.038], [7.494, -26.918], [-0.1, -0.071], [-18.572, -0.625], [-3.925, -9.627], [-0.085, 0.014]],
                  "o": [[0, 0], [0.099, 0.057], [2.83, -6.783], [16.253, 0.555], [0.099, -0.029], [-2.218, -13.438]],
                  "v": [[-0.106, -14.157], [-29.954, 11.639], [-29.641, 11.837], [0.577, -10.844], [29.657, 15.279], [29.954, 15.208]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.803921568627, 0.917647058824, 0.890196078431, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [38.808, 15.53],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 5",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 5,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-2.218, -13.452], [1.897, -4.037], [10.328, 0], [11.433, 6.232], [0.101, 1.493], [0, 0], [0, 0]],
                  "o": [[0, 0], [-5.408, 1.034], [-8.522, 0], [-0.379, -0.208], [-0.36, -5.314], [7.494, -26.905], [20.164, 1.024]],
                  "v": [[30.17, 3.798], [30.17, 22.936], [-0.602, 26.676], [-29.739, 19.367], [-31.707, 17.822], [-29.739, 0.229], [0.109, -25.566]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.945098099054, 0.968627510819, 0.909803981407, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [38.579, 27.209],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 6",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 6,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-3.413, -0.64], [-11.849, 0.096], [0, 0], [0, 0], [0, 0]],
                  "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [10.958, -0.09], [0, 0], [0, 0], [0, 0]],
                  "v": [[17.692, 1.136], [0.821, 2.132], [-16.464, 0.35], [-17.136, 0.35], [-17.134, 0.311], [-28.443, -4.545], [-27.783, -1.68], [-17.233, 2.302], [0.91, 4.449], [17.692, 3.141], [28.443, 1.463], [28.443, -0.826]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [37.707, 52.208],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 7",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 7,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 30,
          "op": 31,
          "st": 30,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 4,
          "ty": 4,
          "nm": "15",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [153.748, 33.861, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.347, 20.35, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[20.164, 1.038], [7.494, -26.918], [-0.1, -0.071], [-18.572, -0.625], [-3.925, -9.627], [-0.085, 0.014]],
                  "o": [[0, 0], [0.099, 0.057], [2.83, -6.783], [16.253, 0.555], [0.099, -0.029], [-2.218, -13.438]],
                  "v": [[-0.106, -14.157], [-29.954, 11.639], [-29.641, 11.837], [0.577, -10.844], [29.657, 15.279], [29.954, 15.208]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980451995, 0.933333393172, 0.89019613827, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.361, 15.53],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [13.978, 0], [2.375, 2.09]],
                  "o": [[0, 0], [-13.978, 0], [0, 0]],
                  "v": [[29.954, -0.086], [-0.818, 3.654], [-29.954, -3.654]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.347, 30.653],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-2.218, -13.452], [18.401, 0], [0, 0], [0, 0]],
                  "o": [[0, 0], [-18.401, 0], [7.494, -26.905], [20.164, 1.024]],
                  "v": [[29.954, 13.367], [-0.818, 17.107], [-29.954, 9.798], [-0.107, -15.998]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.945098099054, 0.968627510819, 0.909803981407, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.347, 17.641],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [-3.413, -0.64], [0, 0], [0, 0]],
                  "o": [[0, 0], [0, 0], [0, 0], [0, 0]],
                  "v": [[-5.325, -0.683], [5.226, 3.299], [5.325, 1.309], [-4.728, -3.299]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [13.041, 31.449],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 4",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 4,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                  "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                  "v": [[-5.376, -0.021], [5.376, -1.984], [5.376, 0.306], [-5.376, 1.984], [-5.376, 0.306]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [58.566, 33.604],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 5",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 5,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 31,
          "op": 32,
          "st": 31,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 5,
          "ty": 4,
          "nm": "14",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [152.525, 43.65, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [37.571, 30.139, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [13.978, 0], [5.431, 2.268], [0.696, 0.612]],
                  "o": [[0, 0], [-9.886, 0], [-2.249, -0.939], [0, 0]],
                  "v": [[31.178, 0.388], [0.406, 4.128], [-24.199, -0.75], [-31.178, -4.128]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [37.571, 49.757],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0.02, 3.235], [0.512, 3.1], [0, 0], [0.981, -0.228], [0.817, -5.354], [0, 0]],
                  "o": [[-0.014, -2.759], [0, 0], [-0.825, 0.214], [0.377, 7.542], [0, 0], [0.503, -3.668]],
                  "v": [[2.095, -1.071], [1.342, -9.943], [1.356, -9.958], [-1.36, -9.29], [-2.115, 9.958], [1.444, 9.419]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.803921568627, 0.917647058824, 0.890196078431, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [67.393, 40.526],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-0.389, 3.568], [0.54, 0.356], [0.199, -6.669], [-0.059, -1.291], [0, 0]],
                  "o": [[-0.725, -0.412], [-1.323, 4.75], [0, 0], [0, 0], [-0.581, -8.236]],
                  "v": [[2.154, -9.125], [0.249, -10.277], [-2.14, 6.759], [-2.095, 8.822], [1.374, 10.277]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.803921568627, 0.917647058824, 0.890196078431, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [8.591, 37.275],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[9.858, 1.082], [6.476, -3.544], [1.433, -2.26], [1.036, -3.212], [0, 0], [0, 0], [-3.607, 3.366], [-8.536, 0], [-2.044, -3.125], [0, 0], [0, 0], [2.314, 8.138], [1.923, 2.464]],
                  "o": [[-4.983, -0.547], [-4.304, 2.355], [-2.765, 4.364], [-0.777, 2.409], [0, 0], [0, 0], [3.607, -3.366], [8.536, 0], [2.044, 3.126], [0, 0], [0, 0], [-1.008, -3.544], [-3.848, -4.93]],
                  "v": [[2.807, -15.177], [-13.31, -11.39], [-22.004, -2.437], [-27.605, 9.823], [-28.857, 17.942], [-29.947, 7.998], [-21.6, -8.685], [1.363, -17.942], [24.087, -5.319], [29.947, 11.581], [27.352, 17.848], [25.419, 5.848], [20.72, -4.236]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.803921568627, 0.917647058824, 0.890196078431, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [38.801, 19],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 4",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 4,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[20.164, 1.038], [7.494, -26.918], [-0.1, -0.071], [-18.572, -0.625], [-3.925, -9.627], [-0.085, 0.014]],
                  "o": [[0, 0], [0.099, 0.057], [2.83, -6.783], [16.253, 0.555], [0.099, -0.029], [-2.218, -13.438]],
                  "v": [[-0.106, -14.157], [-29.954, 11.639], [-29.641, 11.837], [0.577, -10.844], [29.657, 15.279], [29.954, 15.208]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.803921568627, 0.917647058824, 0.890196078431, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [38.808, 15.53],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 5",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 5,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-2.218, -13.452], [1.897, -4.037], [10.328, 0], [11.433, 6.232], [0.101, 1.493], [0, 0], [0, 0]],
                  "o": [[0, 0], [-5.408, 1.034], [-8.522, 0], [-0.379, -0.208], [-0.36, -5.314], [7.494, -26.905], [20.164, 1.024]],
                  "v": [[30.17, 3.798], [30.17, 22.936], [-0.602, 26.676], [-29.739, 19.367], [-31.707, 17.822], [-29.739, 0.229], [0.109, -25.566]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.945098099054, 0.968627510819, 0.909803981407, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [38.579, 27.209],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 6",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 6,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-3.413, -0.64], [-11.849, 0.096], [0, 0], [0, 0], [0, 0]],
                  "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [10.958, -0.09], [0, 0], [0, 0], [0, 0]],
                  "v": [[17.692, 1.136], [0.821, 2.132], [-16.464, 0.35], [-17.136, 0.35], [-17.134, 0.311], [-28.443, -4.545], [-27.783, -1.68], [-17.233, 2.302], [0.91, 4.449], [17.692, 3.141], [28.443, 1.463], [28.443, -0.826]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.780392216701, 0.772549079446, 0.776470648074, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [37.707, 52.208],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 7",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 7,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 119,
          "op": 120,
          "st": 119,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 6,
          "ty": 4,
          "nm": "13",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [153.238, 53.121, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [32.385, 39.609, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [8.381, 0], [5.547, 2.115], [0.447, 0.187]],
                  "o": [[-6.179, 1.077], [-9.071, 0], [-0.498, -0.189], [0, 0]],
                  "v": [[24.779, 0.191], [0.826, 2.612], [-22.361, -1.701], [-24.779, -2.612]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [31.252, 70.214],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0.512, 3.1], [0, 0], [0.981, -0.227], [6.157, -6.33], [0, 0], [0.06, 9.812]],
                  "o": [[0, 0], [-0.825, 0.213], [1.111, 22.247], [0, 0], [7.744, -8.833], [-0.014, -2.758]],
                  "v": [[5.909, -20.572], [5.923, -20.585], [3.207, -19.917], [-6.722, 20.586], [-2.64, 19.967], [6.662, -11.699]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.803921628466, 0.917647118662, 0.89019613827, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [56.927, 51.153],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-0.765, 7.008], [0.54, 0.356], [0.199, -6.669], [-6.896, -10.81], [0, 0]],
                  "o": [[-0.725, -0.412], [-1.323, 4.75], [0, 0], [0, 0], [-10.914, -12.402]],
                  "v": [[-1.281, -20.398], [-3.186, -21.551], [-5.575, -4.514], [1.02, 20.57], [5.876, 21.551]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.803921568627, 0.917647058824, 0.890196078431, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [6.126, 48.549],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[9.858, 1.082], [6.476, -3.544], [1.433, -2.26], [1.036, -3.212], [0, 0], [0, 0], [-3.607, 3.366], [-8.536, 0], [-2.044, -3.125], [0, 0], [0, 0], [2.314, 8.138], [1.923, 2.464]],
                  "o": [[-4.983, -0.547], [-4.304, 2.355], [-2.765, 4.364], [-0.777, 2.409], [0, 0], [0, 0], [3.607, -3.366], [8.536, 0], [2.044, 3.126], [0, 0], [0, 0], [-1.008, -3.544], [-3.848, -4.93]],
                  "v": [[2.807, -15.177], [-13.31, -11.39], [-22.004, -2.437], [-27.605, 9.823], [-28.857, 17.942], [-29.947, 7.998], [-21.6, -8.685], [1.363, -17.942], [24.087, -5.319], [29.947, 11.581], [27.352, 17.848], [25.419, 5.848], [20.72, -4.236]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.803921568627, 0.917647058824, 0.890196078431, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [32.903, 19],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 4",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 4,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[20.164, 1.038], [7.494, -26.918], [-0.1, -0.071], [-18.572, -0.625], [-3.925, -9.627], [-0.085, 0.014]],
                  "o": [[0, 0], [0.099, 0.057], [2.83, -6.783], [16.253, 0.555], [0.099, -0.029], [-2.218, -13.438]],
                  "v": [[-0.106, -14.157], [-29.954, 11.639], [-29.641, 11.837], [0.577, -10.844], [29.657, 15.279], [29.954, 15.208]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.803921568627, 0.917647058824, 0.890196078431, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [32.909, 15.53],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 5",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 5,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-2.218, -13.452], [1.554, -10.737], [0, 0], [5.299, 0], [9.027, 4.258], [0.101, 1.494], [0, 0], [0, 0]],
                  "o": [[0, 0], [-1.554, 10.736], [0, 0], [-8.522, 0], [-4.238, -7.911], [-0.36, -5.313], [7.494, -26.905], [20.164, 1.024]],
                  "v": [[30.366, -5.753], [30.482, 15.637], [23.56, 33.719], [-0.406, 36.227], [-26.167, 30.187], [-31.676, 9.703], [-29.543, -9.322], [0.305, -35.118]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.945098099054, 0.968627510819, 0.909803981407, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [32.484, 36.761],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 6",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 6,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-1.707, -0.32], [-11.849, 0.096], [0, 0], [0, 0], [0, 0]],
                  "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [2.211, 0.915], [0, 0], [10.958, -0.09], [0, 0], [0, 0], [0, 0]],
                  "v": [[18.572, 0.817], [1.701, 1.813], [-15.583, 0.031], [-16.256, 0.031], [-16.254, -0.008], [-24.611, -4.226], [-22.908, -0.638], [-16.353, 1.593], [1.789, 4.13], [18.802, 2.575], [22.829, 1.947], [24.611, -0.285]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.780392216701, 0.772549079446, 0.776470648074, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [30.928, 71.175],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 7",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 7,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 118,
          "op": 119,
          "st": 118,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 7,
          "ty": 4,
          "nm": "3",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [153.238, 53.121, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [32.385, 39.609, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [8.381, 0], [5.547, 2.115], [0.447, 0.187]],
                  "o": [[-6.179, 1.077], [-9.071, 0], [-0.498, -0.189], [0, 0]],
                  "v": [[24.779, 0.191], [0.826, 2.612], [-22.361, -1.701], [-24.779, -2.612]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [31.252, 70.214],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[20.164, 1.038], [7.494, -26.918], [-0.1, -0.071], [-18.572, -0.625], [-3.925, -9.627], [-0.085, 0.014]],
                  "o": [[0, 0], [0.099, 0.057], [2.83, -6.783], [16.253, 0.555], [0.099, -0.029], [-2.218, -13.438]],
                  "v": [[-0.106, -14.157], [-29.954, 11.639], [-29.641, 11.837], [0.577, -10.844], [29.657, 15.279], [29.954, 15.208]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.803921568627, 0.917647058824, 0.890196078431, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [32.909, 15.53],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 5",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 5,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-2.218, -13.452], [1.554, -10.737], [0, 0], [5.299, 0], [9.027, 4.258], [0.101, 1.494], [0, 0], [0, 0]],
                  "o": [[0, 0], [-1.554, 10.736], [0, 0], [-8.522, 0], [-4.238, -7.911], [-0.36, -5.313], [7.494, -26.905], [20.164, 1.024]],
                  "v": [[30.366, -5.753], [30.482, 15.637], [23.56, 33.719], [-0.406, 36.227], [-26.167, 30.187], [-31.676, 9.703], [-29.543, -9.322], [0.305, -35.118]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.945098099054, 0.968627510819, 0.909803981407, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [32.484, 36.761],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 6",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 6,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-1.707, -0.32], [-11.849, 0.096], [0, 0], [0, 0], [0, 0]],
                  "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [2.211, 0.915], [0, 0], [10.958, -0.09], [0, 0], [0, 0], [0, 0]],
                  "v": [[18.572, 0.817], [1.701, 1.813], [-15.583, 0.031], [-16.256, 0.031], [-16.254, -0.008], [-24.611, -4.226], [-22.908, -0.638], [-16.353, 1.593], [1.789, 4.13], [18.802, 2.575], [22.829, 1.947], [24.611, -0.285]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [30.928, 71.175],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 7",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 7,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 1,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 8,
          "ty": 4,
          "nm": "1",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [152.525, 43.65, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [37.571, 30.139, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [13.978, 0], [5.431, 2.268], [0.696, 0.612]],
                  "o": [[0, 0], [-9.886, 0], [-2.249, -0.939], [0, 0]],
                  "v": [[31.178, 0.388], [0.406, 4.128], [-24.199, -0.75], [-31.178, -4.128]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [37.571, 49.757],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[20.164, 1.038], [7.494, -26.918], [-0.1, -0.071], [-18.572, -0.625], [-3.925, -9.627], [-0.085, 0.014]],
                  "o": [[0, 0], [0.099, 0.057], [2.83, -6.783], [16.253, 0.555], [0.099, -0.029], [-2.218, -13.438]],
                  "v": [[-0.106, -14.157], [-29.954, 11.639], [-29.641, 11.837], [0.577, -10.844], [29.657, 15.279], [29.954, 15.208]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.803921568627, 0.917647058824, 0.890196078431, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [38.808, 15.53],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 5",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 5,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-2.218, -13.452], [1.897, -4.037], [10.328, 0], [11.433, 6.232], [0.101, 1.493], [0, 0], [0, 0]],
                  "o": [[0, 0], [-5.408, 1.034], [-8.522, 0], [-0.379, -0.208], [-0.36, -5.314], [7.494, -26.905], [20.164, 1.024]],
                  "v": [[30.17, 3.798], [30.17, 22.936], [-0.602, 26.676], [-29.739, 19.367], [-31.707, 17.822], [-29.739, 0.229], [0.109, -25.566]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.945098099054, 0.968627510819, 0.909803981407, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [38.579, 27.209],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 6",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 6,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-3.413, -0.64], [-11.849, 0.096], [0, 0], [0, 0], [0, 0]],
                  "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [10.958, -0.09], [0, 0], [0, 0], [0, 0]],
                  "v": [[17.692, 1.136], [0.821, 2.132], [-16.464, 0.35], [-17.136, 0.35], [-17.134, 0.311], [-28.443, -4.545], [-27.783, -1.68], [-17.233, 2.302], [0.91, 4.449], [17.692, 3.141], [28.443, 1.463], [28.443, -0.826]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [37.707, 52.208],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 7",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 7,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 1,
          "op": 2,
          "st": 1,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 9,
          "ty": 4,
          "nm": "0",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [153.748, 33.861, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.347, 20.35, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[20.164, 1.038], [7.494, -26.918], [-0.1, -0.071], [-18.572, -0.625], [-3.925, -9.627], [-0.085, 0.014]],
                  "o": [[0, 0], [0.099, 0.057], [2.83, -6.783], [16.253, 0.555], [0.099, -0.029], [-2.218, -13.438]],
                  "v": [[-0.106, -14.157], [-29.954, 11.639], [-29.641, 11.837], [0.577, -10.844], [29.657, 15.279], [29.954, 15.208]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980451995, 0.933333393172, 0.89019613827, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.361, 15.53],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [13.978, 0], [2.375, 2.09]],
                  "o": [[0, 0], [-13.978, 0], [0, 0]],
                  "v": [[29.954, -0.086], [-0.818, 3.654], [-29.954, -3.654]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.347, 30.653],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-2.218, -13.452], [18.401, 0], [0, 0], [0, 0]],
                  "o": [[0, 0], [-18.401, 0], [7.494, -26.905], [20.164, 1.024]],
                  "v": [[29.954, 13.367], [-0.818, 17.107], [-29.954, 9.798], [-0.107, -15.998]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.945098099054, 0.968627510819, 0.909803981407, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.347, 17.641],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [-3.413, -0.64], [0, 0], [0, 0]],
                  "o": [[0, 0], [0, 0], [0, 0], [0, 0]],
                  "v": [[-5.325, -0.683], [5.226, 3.299], [5.325, 1.309], [-4.728, -3.299]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [13.041, 31.449],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 4",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 4,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                  "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                  "v": [[-5.376, -0.021], [5.376, -1.984], [5.376, 0.306], [-5.376, 1.984], [-5.376, 0.306]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [58.566, 33.604],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 5",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 5,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 2,
          "op": 3,
          "st": 2,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 10,
          "ty": 4,
          "nm": "mabuta 2",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [154.307, 24.896, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [30.939, 10.847, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [-0.439, 0.072], [-7.604, 0], [-5.439, -1.778], [-0.556, -0.2]],
                  "o": [[0.414, -0.071], [6.114, -1.009], [7.721, 0], [0.606, 0.198], [0, 0]],
                  "v": [[-24.546, 0.162], [-21.898, -0.314], [0.258, -2.43], [20.775, 0.94], [24.546, 2.43]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [30.939, 12.872],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[10.64, 0.548], [9.302, -9.822], [-0.341, -0.072], [-0.961, 0.472], [-7.358, -0.248], [-4.479, -4.266], [0.133, 1.193]],
                  "o": [[0, 0], [-1.306, 1.828], [1.023, 0.217], [4.53, -3.464], [7.057, 0.241], [3.258, 0.738], [-4.719, -6.013]],
                  "v": [[-0.191, -5.786], [-21.159, 3.45], [-20.764, 5.764], [-17.223, 3.187], [0.492, -2.473], [17.699, 5.175], [22.332, 5.179]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.803921568627, 0.917647058824, 0.890196078431, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [30.478, 6.622],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0.991, 1.782], [7.966, 0], [3.688, -0.398], [1.01, 0.881], [0.718, 0.304], [-0.31, 0.349], [0, 0], [-4.714, -6.232]],
                  "o": [[0.508, 1.458], [-3.535, 0], [-3.497, 0.378], [-0.194, -0.169], [0.304, -0.373], [9.397, -10.538], [10.892, 0.553], [0.796, 0.625]],
                  "v": [[22.592, 5.416], [-0.135, 2.743], [-14.488, 3.796], [-22.667, 4.404], [-23.583, 4.422], [-22.66, 3.34], [-1.059, -6.592], [21.796, 4.791]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.945098099054, 0.968627510819, 0.909803981407, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [31.331, 7.699],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 120,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 11,
          "ty": 4,
          "nm": "mabuta",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [154.307, 26.396, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [30.939, 10.847, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [-0.439, 0.072], [-7.604, 0], [-5.439, -1.778], [-0.556, -0.2]],
                  "o": [[0.414, -0.071], [6.114, -1.009], [7.721, 0], [0.606, 0.198], [0, 0]],
                  "v": [[-24.546, 0.162], [-21.898, -0.314], [0.258, -2.43], [20.775, 0.94], [24.546, 2.43]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [30.939, 12.872],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 120,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 12,
          "ty": 4,
          "nm": "kuromehikari",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [152.93, 48.712, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [20.385, 16.179, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0.014, 0.014], [-1.878, 0.029], [-0.825, 0.64], [-1.422, -0.227], [1.536, -1.891], [1.906, 0.484]],
                  "o": [[-1.806, -0.484], [0.938, -0.014], [1.663, -1.308], [1.422, 0.228], [-1.536, 1.891], [-0.014, 0]],
                  "v": [[-3.569, 3.285], [-3.1, -0.001], [-0.184, -0.839], [3.129, -3.555], [3.84, 1.408], [-3.512, 3.299]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.478431402468, 0.784313785329, 0.882353001015, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [26.514, 26.207],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 120,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 13,
          "ty": 4,
          "nm": "siro6",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [145.247, 52.177, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [12.702, 19.644, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 1,
              "k": [{
                "i": {
                  "x": [0.667, 0.667, 0.667],
                  "y": [1, 1, 1]
                },
                "o": {
                  "x": [0.333, 0.333, 0.333],
                  "y": [0, 0, 0]
                },
                "t": 0,
                "s": [100, 100, 100]
              }, {
                "i": {
                  "x": [0.667, 0.667, 0.667],
                  "y": [1, 1, 1]
                },
                "o": {
                  "x": [0.333, 0.333, 0.333],
                  "y": [0, 0, 0]
                },
                "t": 13,
                "s": [115, 115, 100]
              }, {
                "i": {
                  "x": [0.667, 0.667, 0.667],
                  "y": [1, 1, 1]
                },
                "o": {
                  "x": [0.333, 0.333, 0.333],
                  "y": [0, 0, 0]
                },
                "t": 30,
                "s": [100, 100, 100]
              }, {
                "i": {
                  "x": [0.667, 0.667, 0.667],
                  "y": [1, 1, 1]
                },
                "o": {
                  "x": [0.333, 0.333, 0.333],
                  "y": [0, 0, 0]
                },
                "t": 43,
                "s": [115, 115, 100]
              }, {
                "i": {
                  "x": [0.667, 0.667, 0.667],
                  "y": [1, 1, 1]
                },
                "o": {
                  "x": [0.333, 0.333, 0.333],
                  "y": [0, 0, 0]
                },
                "t": 60,
                "s": [100, 100, 100]
              }, {
                "i": {
                  "x": [0.667, 0.667, 0.667],
                  "y": [1, 1, 1]
                },
                "o": {
                  "x": [0.333, 0.333, 0.333],
                  "y": [0, 0, 0]
                },
                "t": 73,
                "s": [115, 115, 100]
              }, {
                "i": {
                  "x": [0.667, 0.667, 0.667],
                  "y": [1, 1, 1]
                },
                "o": {
                  "x": [0.333, 0.333, 0.333],
                  "y": [0, 0, 0]
                },
                "t": 90,
                "s": [100, 100, 100]
              }, {
                "i": {
                  "x": [0.667, 0.667, 0.667],
                  "y": [1, 1, 1]
                },
                "o": {
                  "x": [0.333, 0.333, 0.333],
                  "y": [0, 0, 0]
                },
                "t": 103,
                "s": [115, 115, 100]
              }, {
                "i": {
                  "x": [0.667, 0.667, 0.667],
                  "y": [1, 1, 1]
                },
                "o": {
                  "x": [0.333, 0.333, 0.333],
                  "y": [0, 0, 0]
                },
                "t": 120,
                "s": [100, 100, 100]
              }, {
                "t": 133,
                "s": [105, 105, 100]
              }],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-3.016, 0], [0, 2.928], [3.016, 0], [0, -2.927]],
                  "o": [[3.016, 0], [0, -2.927], [-3.016, 0], [0, 2.928]],
                  "v": [[0, 5.301], [5.462, 0], [0, -5.301], [-5.462, 0]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.996078491211, 0.996078491211, 0.992156922583, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [12.729, 19.44],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 4",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 120,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 14,
          "ty": 4,
          "nm": "siro5",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [162.289, 47.448, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [29.745, 14.914, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 1,
              "k": [{
                "i": {
                  "x": [0.667, 0.667, 0.667],
                  "y": [1, 1, 1]
                },
                "o": {
                  "x": [0.333, 0.333, 0.333],
                  "y": [0, 0, 0]
                },
                "t": 0,
                "s": [100, 100, 100]
              }, {
                "i": {
                  "x": [0.667, 0.667, 0.667],
                  "y": [1, 1, 1]
                },
                "o": {
                  "x": [0.333, 0.333, 0.333],
                  "y": [0, 0, 0]
                },
                "t": 13,
                "s": [110, 110, 100]
              }, {
                "i": {
                  "x": [0.667, 0.667, 0.667],
                  "y": [1, 1, 1]
                },
                "o": {
                  "x": [0.333, 0.333, 0.333],
                  "y": [0, 0, 0]
                },
                "t": 30,
                "s": [100, 100, 100]
              }, {
                "i": {
                  "x": [0.667, 0.667, 0.667],
                  "y": [1, 1, 1]
                },
                "o": {
                  "x": [0.333, 0.333, 0.333],
                  "y": [0, 0, 0]
                },
                "t": 43,
                "s": [110, 110, 100]
              }, {
                "i": {
                  "x": [0.667, 0.667, 0.667],
                  "y": [1, 1, 1]
                },
                "o": {
                  "x": [0.333, 0.333, 0.333],
                  "y": [0, 0, 0]
                },
                "t": 60,
                "s": [100, 100, 100]
              }, {
                "i": {
                  "x": [0.667, 0.667, 0.667],
                  "y": [1, 1, 1]
                },
                "o": {
                  "x": [0.333, 0.333, 0.333],
                  "y": [0, 0, 0]
                },
                "t": 73,
                "s": [110, 110, 100]
              }, {
                "i": {
                  "x": [0.667, 0.667, 0.667],
                  "y": [1, 1, 1]
                },
                "o": {
                  "x": [0.333, 0.333, 0.333],
                  "y": [0, 0, 0]
                },
                "t": 90,
                "s": [100, 100, 100]
              }, {
                "i": {
                  "x": [0.667, 0.667, 0.667],
                  "y": [1, 1, 1]
                },
                "o": {
                  "x": [0.333, 0.333, 0.333],
                  "y": [0, 0, 0]
                },
                "t": 103,
                "s": [110, 110, 100]
              }, {
                "t": 120,
                "s": [100, 100, 100]
              }],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-3.293, 0.43], [0.379, 2.903], [3.293, -0.431], [-0.379, -2.903]],
                  "o": [[3.293, -0.43], [-0.38, -2.902], [-3.293, 0.43], [0.38, 2.903]],
                  "v": [[0.687, 5.257], [5.963, -0.779], [-0.687, -5.255], [-5.963, 0.779]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.996078491211, 0.996078491211, 0.992156922583, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [29.418, 14.68],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 120,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 15,
          "ty": 4,
          "nm": "siro4",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [152.93, 48.712, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [20.385, 16.179, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-2.79, 0.451], [0.354, 2.19], [2.79, -0.452], [-0.354, -2.19]],
                  "o": [[2.79, -0.451], [-0.354, -2.19], [-2.79, 0.451], [0.354, 2.19]],
                  "v": [[0.642, 3.965], [5.053, -0.817], [-0.642, -3.964], [-5.053, 0.818]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.996078491211, 0.996078491211, 0.992156922583, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [17.92, 8.121],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 1,
                "k": [{
                  "i": {
                    "x": [0.667, 0.667],
                    "y": [1, 1]
                  },
                  "o": {
                    "x": [0.333, 0.333],
                    "y": [0, 0]
                  },
                  "t": 0,
                  "s": [100, 100]
                }, {
                  "i": {
                    "x": [0.667, 0.667],
                    "y": [1, 1]
                  },
                  "o": {
                    "x": [0.333, 0.333],
                    "y": [0, 0]
                  },
                  "t": 13,
                  "s": [119, 119]
                }, {
                  "i": {
                    "x": [0.667, 0.667],
                    "y": [1, 1]
                  },
                  "o": {
                    "x": [0.333, 0.333],
                    "y": [0, 0]
                  },
                  "t": 30,
                  "s": [100, 100]
                }, {
                  "i": {
                    "x": [0.667, 0.667],
                    "y": [1, 1]
                  },
                  "o": {
                    "x": [0.333, 0.333],
                    "y": [0, 0]
                  },
                  "t": 43,
                  "s": [119, 119]
                }, {
                  "i": {
                    "x": [0.667, 0.667],
                    "y": [1, 1]
                  },
                  "o": {
                    "x": [0.333, 0.333],
                    "y": [0, 0]
                  },
                  "t": 60,
                  "s": [100, 100]
                }, {
                  "i": {
                    "x": [0.667, 0.667],
                    "y": [1, 1]
                  },
                  "o": {
                    "x": [0.333, 0.333],
                    "y": [0, 0]
                  },
                  "t": 73,
                  "s": [119, 119]
                }, {
                  "i": {
                    "x": [0.667, 0.667],
                    "y": [1, 1]
                  },
                  "o": {
                    "x": [0.333, 0.333],
                    "y": [0, 0]
                  },
                  "t": 90,
                  "s": [100, 100]
                }, {
                  "i": {
                    "x": [0.667, 0.667],
                    "y": [1, 1]
                  },
                  "o": {
                    "x": [0.333, 0.333],
                    "y": [0, 0]
                  },
                  "t": 103,
                  "s": [119, 119]
                }, {
                  "t": 120,
                  "s": [100, 100]
                }],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 120,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 19,
          "ty": 4,
          "nm": "kurome",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [152.93, 48.712, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [20.385, 16.179, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [13.088, 0], [0.88, -5.344], [0.002, -0.019], [0, 0], [-20.136, 0]],
                  "o": [[-0.734, -5.626], [-11.444, 0], [-0.004, 0.018], [-0.001, 0], [0, 0], [20.135, 0]],
                  "v": [[17.548, -2.074], [0.38, -15.929], [-17.1, -3.069], [-17.102, -3.012], [-17.107, -3.012], [0, 15.929]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.400000029919, 0.756862804936, 0.870588295133, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [20.385, 16.179],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 5",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 120,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 20,
          "ty": 4,
          "nm": "sirome",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [152.013, 56.419, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [32.778, 42.956, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[9.858, 1.082], [6.476, -3.544], [1.433, -2.26], [1.036, -3.212], [0, 0], [0, 0], [-3.607, 3.366], [-8.536, 0], [-2.044, -3.125], [0, 0], [0, 0], [2.314, 8.138], [1.923, 2.464]],
                  "o": [[-4.983, -0.547], [-4.304, 2.355], [-2.765, 4.364], [-0.777, 2.409], [0, 0], [0, 0], [3.607, -3.366], [8.536, 0], [2.044, 3.126], [0, 0], [0, 0], [-1.008, -3.544], [-3.848, -4.93]],
                  "v": [[2.807, -15.177], [-13.31, -11.39], [-22.004, -2.437], [-27.605, 9.823], [-28.857, 17.942], [-29.947, 7.998], [-21.6, -8.685], [1.363, -17.942], [24.087, -5.319], [29.947, 11.581], [27.352, 17.848], [25.419, 5.848], [20.72, -4.236]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [34.521, 19.049],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [0.981, -0.227], [0, 0], [-1.038, 9.513], [0.54, 0.355], [0.199, -6.669], [-29.706, 0], [0.1, 16.324], [0.512, 3.1]],
                  "o": [[-0.825, 0.213], [2.716, 54.378], [-31.128, -2.532], [-0.725, -0.413], [-1.323, 4.749], [0, 0], [29.706, 0], [-0.014, -2.759], [0, 0]],
                  "v": [[31.69, -25.739], [28.974, -25.07], [-1.401, 22.042], [-26.314, -28.156], [-28.219, -29.307], [-30.609, -12.273], [-1.7, 24.701], [32.429, -16.851], [31.676, -25.725]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [32.778, 56.355],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [12.347, 8.565], [6.563, -3.003], [0, 0], [0.199, -6.669], [-29.706, 0], [0.1, 16.324], [0.512, 3.1]],
                  "o": [[0, 0], [-8.009, -3.56], [-14.906, 4.338], [-1.323, 4.749], [0, 0], [29.706, 0], [-0.014, -2.759], [0, 0]],
                  "v": [[31.128, -10.036], [15.125, -36.732], [-8.345, -37.4], [-28.781, -13.605], [-31.17, 3.43], [-2.261, 40.402], [31.867, -1.148], [31.114, -10.023]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 1, 1, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [33.34, 40.653],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 120,
          "st": 0,
          "bm": 0
        }]
      }],
      "layers": [{
        "ddd": 0,
        "ind": 1,
        "ty": 0,
        "nm": "kirakira_parts",
        "parent": 6,
        "refId": "comp_0",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [-17.596, 40.692, 0],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [101.5, 53, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100, 100],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "w": 203,
        "h": 106,
        "ip": 0,
        "op": 120,
        "st": 0,
        "bm": 0
      }, {
        "ddd": 0,
        "ind": 2,
        "ty": 0,
        "nm": "kirakira_parts",
        "parent": 6,
        "refId": "comp_0",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [85.404, 40.692, 0],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [101.5, 53, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100, 100],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "w": 203,
        "h": 106,
        "ip": 0,
        "op": 120,
        "st": 0,
        "bm": 0
      }, {
        "ddd": 0,
        "ind": 6,
        "ty": 3,
        "nm": "size web",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [85.846, 29.558, 0],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [85.25, 29.25, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100, 100],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "ip": 0,
        "op": 120,
        "st": 0,
        "bm": 0
      }],
      "markers": []
    };
    let animationData05 = {
      "v": "5.9.2",
      "fr": 30,
      "ip": 0,
      "op": 18,
      "w": 239,
      "h": 90,
      "nm": "warai",
      "ddd": 0,
      "assets": [{
        "id": "comp_0",
        "nm": "warau_eye2",
        "fr": 30,
        "layers": [{
          "ddd": 0,
          "ind": 1,
          "ty": 4,
          "nm": "kurofuchiアウトライン 2",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [85.643, 81.046, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [38.345, 46.977, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [-22.328, 0], [-0.785, -4.322], [0, 0], [-0.014, -2.759], [31.441, 1.209], [0, 0], [-1.238, 4.631], [-0.05, 0.183]],
                  "o": [[1.252, -4.685], [23.02, 0], [0, 0], [0.512, 3.1], [0.099, 16.325], [-29.677, -1.137], [0.192, -6.413], [0.05, -0.185], [0, 0]],
                  "v": [[-28.576, -15.589], [1.721, -40.585], [30.993, -11.708], [31.1, -11.049], [31.854, -2.176], [-2.276, 39.376], [-31.185, 2.404], [-28.946, -14.081], [-28.796, -14.633]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [38.345, 46.977],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 18,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 2,
          "ty": 4,
          "nm": "mabuta kage",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [87.111, 55.338, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.361, 16.088, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[20.164, 1.038], [7.494, -26.918], [-0.1, -0.071], [-18.572, -0.625], [-3.925, -9.627], [-0.085, 0.014]],
                  "o": [[0, 0], [0.099, 0.057], [2.83, -6.783], [16.253, 0.555], [0.099, -0.029], [-2.218, -13.438]],
                  "v": [[-0.106, -14.157], [-29.954, 11.639], [-29.641, 11.837], [0.577, -10.844], [29.657, 15.279], [29.954, 15.208]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.874509803922, 0.933333333333, 0.894117647059, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.361, 15.53],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 96,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 3,
          "ty": 4,
          "nm": "egao_mabutaアウトライン 4",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [86.941, 57.286, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.178, 18.055, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [-5.368, 2.486], [-8.418, -0.013], [-0.59, -0.038]],
                  "o": [[4.845, -3.598], [5.214, -2.415], [19.711, 0.03], [0, 0]],
                  "v": [[-29.786, 5.061], [-18.404, -1.935], [0.887, -5.697], [29.036, 5.225]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.178, 23.743],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[1.679, 1.156], [18.337, -1.39], [2.939, -1.914], [-0.138, -0.334], [0, 0], [-6.991, -3.49]],
                  "o": [[1.103, 1.081], [-18.182, 1.379], [0.939, -3.914], [3.738, -13.616], [10.004, -4.342], [10.723, 3.54]],
                  "v": [[29.983, 10.345], [-3.137, 2.884], [-28.696, 13.45], [-26.494, 7.745], [-11.552, -10.749], [13.98, -10.701]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.945098099054, 0.968627510819, 0.909803981407, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [34.869, 15.482],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 18,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 4,
          "ty": 4,
          "nm": "egao_mabutaアウトライン 3",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [86.941, 59.286, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.178, 18.055, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [-4.711, 2.096], [-7.906, -0.012], [-0.59, -0.038]],
                  "o": [[4.407, -3.473], [4.784, -2.128], [19.711, 0.03], [0, 0]],
                  "v": [[-30.286, 6.123], [-17.604, -1.695], [0.887, -5.697], [29.036, 5.225]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.178, 23.743],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 18,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 5,
          "ty": 4,
          "nm": "egao eyeアウトライン 2",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "s": true,
              "x": {
                "a": 0,
                "k": 95.138,
                "ix": 3
              },
              "y": {
                "a": 0,
                "k": 81.296,
                "ix": 4
              }
            },
            "a": {
              "a": 0,
              "k": [24.204, 20.949, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [-100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [0, 0], [0, 0]],
                  "o": [[0, 0], [0, 0], [0, 0]],
                  "v": [[11.704, 8.449], [-11.704, 6.255], [7.381, -8.449]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215701234, 0.701960784314, 0.847058883368, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 5,
                "ix": 5
              },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [24.204, 20.949],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 18,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 6,
          "ty": 4,
          "nm": "siromeアウトライン 2",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [85.053, 82.323, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [32.779, 42.956, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[9.858, 1.082], [6.476, -3.544], [1.433, -2.26], [1.036, -3.212], [0, 0], [0, 0], [-3.607, 3.366], [-8.536, 0], [-2.044, -3.125], [0, 0], [0, 0], [2.314, 8.138], [1.923, 2.464]],
                  "o": [[-4.983, -0.547], [-4.304, 2.355], [-2.765, 4.364], [-0.777, 2.409], [0, 0], [0, 0], [3.607, -3.366], [8.536, 0], [2.044, 3.126], [0, 0], [0, 0], [-1.008, -3.544], [-3.848, -4.93]],
                  "v": [[2.807, -15.177], [-13.31, -11.39], [-22.004, -2.437], [-27.605, 9.823], [-28.857, 17.942], [-29.948, 7.998], [-21.6, -8.685], [1.363, -17.942], [24.087, -5.319], [29.948, 11.581], [27.353, 17.848], [25.419, 5.848], [20.721, -4.236]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [34.521, 19.049],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [0.981, -0.227], [0, 0], [-1.038, 9.513], [0.54, 0.355], [0.199, -6.669], [-29.706, 0], [0.1, 16.324], [0.512, 3.1]],
                  "o": [[-0.825, 0.213], [2.716, 54.378], [-31.128, -2.532], [-0.725, -0.413], [-1.323, 4.749], [0, 0], [29.706, 0], [-0.014, -2.759], [0, 0]],
                  "v": [[31.69, -25.739], [28.974, -25.07], [-1.401, 22.042], [-26.315, -28.156], [-28.22, -29.307], [-30.609, -12.273], [-1.7, 24.701], [32.429, -16.851], [31.676, -25.725]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [32.778, 56.355],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [12.347, 8.565], [6.563, -3.003], [0, 0], [0.199, -6.669], [-29.706, 0], [0.1, 16.324], [0.512, 3.1]],
                  "o": [[0, 0], [-8.009, -3.56], [-14.906, 4.338], [-1.323, 4.749], [0, 0], [29.706, 0], [-0.014, -2.759], [0, 0]],
                  "v": [[31.128, -10.036], [15.125, -36.732], [-8.345, -37.4], [-28.781, -13.605], [-31.17, 3.43], [-2.261, 40.402], [31.867, -1.148], [31.114, -10.023]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 1, 1, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [33.34, 40.653],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 18,
          "st": 0,
          "bm": 0
        }]
      }, {
        "id": "comp_1",
        "nm": "warau_eye1",
        "fr": 30,
        "layers": [{
          "ddd": 0,
          "ind": 1,
          "ty": 4,
          "nm": "kurofuchiアウトライン",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [188.643, 81.046, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [38.345, 46.977, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [-22.328, 0], [-0.785, -4.322], [0, 0], [-0.014, -2.759], [31.441, 1.209], [0, 0], [-1.238, 4.631], [-0.05, 0.183]],
                  "o": [[1.252, -4.685], [23.02, 0], [0, 0], [0.512, 3.1], [0.099, 16.325], [-29.677, -1.137], [0.192, -6.413], [0.05, -0.185], [0, 0]],
                  "v": [[-28.576, -15.589], [1.721, -40.585], [30.993, -11.708], [31.1, -11.049], [31.854, -2.176], [-2.276, 39.376], [-31.185, 2.404], [-28.946, -14.081], [-28.796, -14.633]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [38.345, 46.977],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 18,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 2,
          "ty": 4,
          "nm": "mabuta kage",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [190.111, 55.338, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.361, 16.088, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[20.164, 1.038], [7.494, -26.918], [-0.1, -0.071], [-18.572, -0.625], [-3.925, -9.627], [-0.085, 0.014]],
                  "o": [[0, 0], [0.099, 0.057], [2.83, -6.783], [16.253, 0.555], [0.099, -0.029], [-2.218, -13.438]],
                  "v": [[-0.106, -14.157], [-29.954, 11.639], [-29.641, 11.837], [0.577, -10.844], [29.657, 15.279], [29.954, 15.208]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.874509803922, 0.933333333333, 0.894117647059, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.361, 15.53],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 96,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 3,
          "ty": 4,
          "nm": "egao_mabutaアウトライン 2",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [189.941, 57.286, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.178, 18.055, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [-22.786, -0.277], [-0.59, -0.038]],
                  "o": [[0.378, -0.184], [19.71, 0.24], [0, 0]],
                  "v": [[-30.036, 5.311], [0.637, -5.697], [29.536, 5.975]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.178, 23.743],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[1.679, 1.156], [18.337, -1.39], [3.128, -1.995], [-0.124, 0.45], [0, 0], [-6.991, -3.49]],
                  "o": [[1.103, 1.081], [-18.182, 1.379], [-2.965, 1.891], [3.738, -13.616], [10.004, -4.342], [10.723, 3.54]],
                  "v": [[29.983, 10.345], [-3.137, 2.884], [-28.696, 13.2], [-26.494, 7.745], [-11.552, -10.749], [13.98, -10.701]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.945098039216, 0.96862745098, 0.909803921569, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [34.869, 15.482],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 18,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 4,
          "ty": 4,
          "nm": "egao_mabutaアウトライン",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [189.941, 59.286, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [36.178, 18.055, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [-22.786, -0.278], [-0.59, -0.038]],
                  "o": [[0.378, -0.184], [19.71, 0.24], [0, 0]],
                  "v": [[-29.786, 5.311], [0.887, -5.697], [29.786, 5.975]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.850980401039, 0.929411768913, 0.960784316063, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 2.557,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [36.178, 23.743],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 18,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 5,
          "ty": 4,
          "nm": "egao eyeアウトライン",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [179.638, 81.296, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [24.204, 20.949, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [0, 0], [0, 0]],
                  "o": [[0, 0], [0, 0], [0, 0]],
                  "v": [[11.704, 8.449], [-11.704, 6.255], [7.381, -8.449]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.239215686275, 0.701960784314, 0.847058823529, 1],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 5,
                "ix": 5
              },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "線 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [24.204, 20.949],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 18,
          "st": 0,
          "bm": 0
        }, {
          "ddd": 0,
          "ind": 6,
          "ty": 4,
          "nm": "siromeアウトライン",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [188.053, 82.323, 0],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [32.779, 42.956, 0],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100, 100],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [{
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[9.858, 1.082], [6.476, -3.544], [1.433, -2.26], [1.036, -3.212], [0, 0], [0, 0], [-3.607, 3.366], [-8.536, 0], [-2.044, -3.125], [0, 0], [0, 0], [2.314, 8.138], [1.923, 2.464]],
                  "o": [[-4.983, -0.547], [-4.304, 2.355], [-2.765, 4.364], [-0.777, 2.409], [0, 0], [0, 0], [3.607, -3.366], [8.536, 0], [2.044, 3.126], [0, 0], [0, 0], [-1.008, -3.544], [-3.848, -4.93]],
                  "v": [[2.807, -15.177], [-13.31, -11.39], [-22.004, -2.437], [-27.605, 9.823], [-28.857, 17.942], [-29.948, 7.998], [-21.6, -8.685], [1.363, -17.942], [24.087, -5.319], [29.948, 11.581], [27.353, 17.848], [25.419, 5.848], [20.721, -4.236]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.866666666667, 0.945098039216, 0.972549019608, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [34.521, 19.049],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [0.981, -0.227], [0, 0], [-1.038, 9.513], [0.54, 0.355], [0.199, -6.669], [-29.706, 0], [0.1, 16.324], [0.512, 3.1]],
                  "o": [[-0.825, 0.213], [2.716, 54.378], [-31.128, -2.532], [-0.725, -0.413], [-1.323, 4.749], [0, 0], [29.706, 0], [-0.014, -2.759], [0, 0]],
                  "v": [[31.69, -25.739], [28.974, -25.07], [-1.401, 22.042], [-26.315, -28.156], [-28.22, -29.307], [-30.609, -12.273], [-1.7, 24.701], [32.429, -16.851], [31.676, -25.725]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.866666666667, 0.945098039216, 0.972549019608, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [32.778, 56.355],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }, {
            "ty": "gr",
            "it": [{
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [12.347, 8.565], [6.563, -3.003], [0, 0], [0.199, -6.669], [-29.706, 0], [0.1, 16.324], [0.512, 3.1]],
                  "o": [[0, 0], [-8.009, -3.56], [-14.906, 4.338], [-1.323, 4.749], [0, 0], [29.706, 0], [-0.014, -2.759], [0, 0]],
                  "v": [[31.128, -10.036], [15.125, -36.732], [-8.345, -37.4], [-28.781, -13.605], [-31.17, 3.43], [-2.261, 40.402], [31.867, -1.148], [31.114, -10.023]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 1, 1, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [33.34, 40.653],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "トランスフォーム"
            }],
            "nm": "グループ 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }],
          "ip": 0,
          "op": 18,
          "st": 0,
          "bm": 0
        }]
      }],
      "layers": [{
        "ddd": 0,
        "ind": 1,
        "ty": 4,
        "nm": "w3/egao2アウトライン",
        "parent": 6,
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [49, 49.25, 0],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [34.5, 42, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100, 100],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "shapes": [{
          "ty": "gr",
          "it": [{
            "ind": 0,
            "ty": "sh",
            "ix": 1,
            "ks": {
              "a": 0,
              "k": {
                "i": [[0, 0], [0, 0]],
                "o": [[0, 0], [0, 0]],
                "v": [[-10.253, -4.072], [2.753, 11.572]],
                "c": false
              },
              "ix": 2
            },
            "nm": "パス 1",
            "mn": "ADBE Vector Shape - Group",
            "hd": false
          }, {
            "ty": "st",
            "c": {
              "a": 0,
              "k": [0.239215701234, 0.701960784314, 0.847058883368, 1],
              "ix": 3
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 4
            },
            "w": {
              "a": 0,
              "k": 4,
              "ix": 5
            },
            "lc": 2,
            "lj": 2,
            "bm": 0,
            "nm": "線 1",
            "mn": "ADBE Vector Graphic - Stroke",
            "hd": false
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [39.666, 13.809],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 3
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 6
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 7
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 4
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 5
            },
            "nm": "トランスフォーム"
          }],
          "nm": "グループ 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }, {
          "ty": "gr",
          "it": [{
            "ind": 0,
            "ty": "sh",
            "ix": 1,
            "ks": {
              "a": 0,
              "k": {
                "i": [[0, 0], [0, 0]],
                "o": [[0, 0], [0, 0]],
                "v": [[-13.139, -6.758], [13.139, 6.758]],
                "c": false
              },
              "ix": 2
            },
            "nm": "パス 1",
            "mn": "ADBE Vector Shape - Group",
            "hd": false
          }, {
            "ty": "st",
            "c": {
              "a": 0,
              "k": [0.239215701234, 0.701960784314, 0.847058883368, 1],
              "ix": 3
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 4
            },
            "w": {
              "a": 0,
              "k": 4,
              "ix": 5
            },
            "lc": 2,
            "lj": 2,
            "bm": 0,
            "nm": "線 1",
            "mn": "ADBE Vector Graphic - Stroke",
            "hd": false
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [19.394, 29.388],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 3
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 6
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 7
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 4
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 5
            },
            "nm": "トランスフォーム"
          }],
          "nm": "グループ 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        }, {
          "ty": "gr",
          "it": [{
            "ind": 0,
            "ty": "sh",
            "ix": 1,
            "ks": {
              "a": 0,
              "k": {
                "i": [[0, 0], [0, 0]],
                "o": [[0, 0], [0, 0]],
                "v": [[-12.951, 1.501], [12.951, -1.501]],
                "c": false
              },
              "ix": 2
            },
            "nm": "パス 1",
            "mn": "ADBE Vector Shape - Group",
            "hd": false
          }, {
            "ty": "st",
            "c": {
              "a": 0,
              "k": [0.239215701234, 0.701960784314, 0.847058883368, 1],
              "ix": 3
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 4
            },
            "w": {
              "a": 0,
              "k": 4,
              "ix": 5
            },
            "lc": 2,
            "lj": 2,
            "bm": 0,
            "nm": "線 1",
            "mn": "ADBE Vector Graphic - Stroke",
            "hd": false
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [15.451, 54.166],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 3
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 6
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 7
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 4
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 5
            },
            "nm": "トランスフォーム"
          }],
          "nm": "グループ 3",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        }, {
          "ty": "gr",
          "it": [{
            "ind": 0,
            "ty": "sh",
            "ix": 1,
            "ks": {
              "a": 0,
              "k": {
                "i": [[0, 0], [0, 6.015], [-23.077, 0]],
                "o": [[-2.288, -5.167], [0, -23.078], [0, 0]],
                "v": [[-17.334, 29.343], [-20.893, 12.443], [20.893, -29.343]],
                "c": false
              },
              "ix": 2
            },
            "nm": "パス 1",
            "mn": "ADBE Vector Shape - Group",
            "hd": false
          }, {
            "ty": "st",
            "c": {
              "a": 0,
              "k": [0.239215701234, 0.701960784314, 0.847058883368, 1],
              "ix": 3
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 4
            },
            "w": {
              "a": 0,
              "k": 4,
              "ix": 5
            },
            "lc": 2,
            "lj": 2,
            "bm": 0,
            "nm": "線 1",
            "mn": "ADBE Vector Graphic - Stroke",
            "hd": false
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [35.599, 41.843],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 3
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 6
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 7
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 4
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 5
            },
            "nm": "トランスフォーム"
          }],
          "nm": "グループ 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        }],
        "ip": 15,
        "op": 18,
        "st": 15,
        "bm": 0
      }, {
        "ddd": 0,
        "ind": 2,
        "ty": 4,
        "nm": "w1アウトライン 2",
        "parent": 6,
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [48.609, 49.779, 0],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [33.393, 41.843, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100, 100],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "shapes": [{
          "ty": "gr",
          "it": [{
            "ind": 0,
            "ty": "sh",
            "ix": 1,
            "ks": {
              "a": 0,
              "k": {
                "i": [[0, 0], [0, 0]],
                "o": [[0, 0], [0, 0]],
                "v": [[-11.88, -3.482], [11.88, 3.482]],
                "c": false
              },
              "ix": 2
            },
            "nm": "パス 1",
            "mn": "ADBE Vector Shape - Group",
            "hd": false
          }, {
            "ty": "st",
            "c": {
              "a": 0,
              "k": [0.239215701234, 0.701960784314, 0.847058883368, 1],
              "ix": 3
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 4
            },
            "w": {
              "a": 0,
              "k": 4,
              "ix": 5
            },
            "lc": 2,
            "lj": 2,
            "bm": 0,
            "nm": "線 1",
            "mn": "ADBE Vector Graphic - Stroke",
            "hd": false
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [17.417, 41.381],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 3
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 6
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 7
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 4
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 5
            },
            "nm": "トランスフォーム"
          }],
          "nm": "グループ 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }, {
          "ty": "gr",
          "it": [{
            "ind": 0,
            "ty": "sh",
            "ix": 1,
            "ks": {
              "a": 0,
              "k": {
                "i": [[0, 0], [0, 0]],
                "o": [[0, 0], [0, 0]],
                "v": [[-13.314, -10.652], [13.314, 10.652]],
                "c": false
              },
              "ix": 2
            },
            "nm": "パス 1",
            "mn": "ADBE Vector Shape - Group",
            "hd": false
          }, {
            "ty": "st",
            "c": {
              "a": 0,
              "k": [0.239215701234, 0.701960784314, 0.847058883368, 1],
              "ix": 3
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 4
            },
            "w": {
              "a": 0,
              "k": 4,
              "ix": 5
            },
            "lc": 2,
            "lj": 2,
            "bm": 0,
            "nm": "線 1",
            "mn": "ADBE Vector Graphic - Stroke",
            "hd": false
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [27.863, 20.284],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 3
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 6
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 7
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 4
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 5
            },
            "nm": "トランスフォーム"
          }],
          "nm": "グループ 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        }, {
          "ty": "gr",
          "it": [{
            "ind": 0,
            "ty": "sh",
            "ix": 1,
            "ks": {
              "a": 0,
              "k": {
                "i": [[0, 0], [0, 6.015], [-23.077, 0]],
                "o": [[-2.288, -5.167], [0, -23.078], [0, 0]],
                "v": [[-17.334, 29.343], [-20.893, 12.443], [20.893, -29.343]],
                "c": false
              },
              "ix": 2
            },
            "nm": "パス 1",
            "mn": "ADBE Vector Shape - Group",
            "hd": false
          }, {
            "ty": "st",
            "c": {
              "a": 0,
              "k": [0.239215701234, 0.701960784314, 0.847058883368, 1],
              "ix": 3
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 4
            },
            "w": {
              "a": 0,
              "k": 4,
              "ix": 5
            },
            "lc": 2,
            "lj": 2,
            "bm": 0,
            "nm": "線 1",
            "mn": "ADBE Vector Graphic - Stroke",
            "hd": false
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [33.393, 41.843],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 3
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 6
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 7
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 4
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 5
            },
            "nm": "トランスフォーム"
          }],
          "nm": "グループ 3",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        }],
        "ip": 10,
        "op": 15,
        "st": 10,
        "bm": 0
      }, {
        "ddd": 0,
        "ind": 3,
        "ty": 4,
        "nm": "w2アウトライン",
        "parent": 6,
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [44.278, 40.949, 0],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [35.87, 32.471, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100, 100],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "shapes": [{
          "ty": "gr",
          "it": [{
            "ind": 0,
            "ty": "sh",
            "ix": 1,
            "ks": {
              "a": 0,
              "k": {
                "i": [[0, 0], [0, 0]],
                "o": [[0, 0], [0, 0]],
                "v": [[-1.229, -9.217], [1.229, 9.217]],
                "c": false
              },
              "ix": 2
            },
            "nm": "パス 1",
            "mn": "ADBE Vector Shape - Group",
            "hd": false
          }, {
            "ty": "st",
            "c": {
              "a": 0,
              "k": [0.239215701234, 0.701960784314, 0.847058883368, 1],
              "ix": 3
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 4
            },
            "w": {
              "a": 0,
              "k": 4,
              "ix": 5
            },
            "lc": 2,
            "lj": 2,
            "bm": 0,
            "nm": "線 1",
            "mn": "ADBE Vector Graphic - Stroke",
            "hd": false
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [49.612, 11.886],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 3
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 6
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 7
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 4
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 5
            },
            "nm": "トランスフォーム"
          }],
          "nm": "グループ 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }, {
          "ty": "gr",
          "it": [{
            "ind": 0,
            "ty": "sh",
            "ix": 1,
            "ks": {
              "a": 0,
              "k": {
                "i": [[0, 0], [0, 0]],
                "o": [[0, 0], [0, 0]],
                "v": [[-7.988, -6.555], [7.988, 6.555]],
                "c": false
              },
              "ix": 2
            },
            "nm": "パス 1",
            "mn": "ADBE Vector Shape - Group",
            "hd": false
          }, {
            "ty": "st",
            "c": {
              "a": 0,
              "k": [0.239215701234, 0.701960784314, 0.847058883368, 1],
              "ix": 3
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 4
            },
            "w": {
              "a": 0,
              "k": 4,
              "ix": 5
            },
            "lc": 2,
            "lj": 2,
            "bm": 0,
            "nm": "線 1",
            "mn": "ADBE Vector Graphic - Stroke",
            "hd": false
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [31.381, 23.152],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 3
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 6
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 7
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 4
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 5
            },
            "nm": "トランスフォーム"
          }],
          "nm": "グループ 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        }, {
          "ty": "gr",
          "it": [{
            "ind": 0,
            "ty": "sh",
            "ix": 1,
            "ks": {
              "a": 0,
              "k": {
                "i": [[0, 0], [0, 0]],
                "o": [[0, 0], [0, 0]],
                "v": [[-16.182, -3.687], [16.182, 3.687]],
                "c": false
              },
              "ix": 2
            },
            "nm": "パス 1",
            "mn": "ADBE Vector Shape - Group",
            "hd": false
          }, {
            "ty": "st",
            "c": {
              "a": 0,
              "k": [0.239215701234, 0.701960784314, 0.847058883368, 1],
              "ix": 3
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 4
            },
            "w": {
              "a": 0,
              "k": 4,
              "ix": 5
            },
            "lc": 2,
            "lj": 2,
            "bm": 0,
            "nm": "線 1",
            "mn": "ADBE Vector Graphic - Stroke",
            "hd": false
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [18.682, 41.996],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 3
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 6
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 7
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 4
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 5
            },
            "nm": "トランスフォーム"
          }],
          "nm": "グループ 3",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        }, {
          "ty": "gr",
          "it": [{
            "ind": 0,
            "ty": "sh",
            "ix": 1,
            "ks": {
              "a": 0,
              "k": {
                "i": [[0, 0], [-22.06, 0]],
                "o": [[0, -22.06], [0, 0]],
                "v": [[-19.971, 19.971], [19.971, -19.971]],
                "c": false
              },
              "ix": 2
            },
            "nm": "パス 1",
            "mn": "ADBE Vector Shape - Group",
            "hd": false
          }, {
            "ty": "st",
            "c": {
              "a": 0,
              "k": [0.239215701234, 0.701960784314, 0.847058883368, 1],
              "ix": 3
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 4
            },
            "w": {
              "a": 0,
              "k": 4,
              "ix": 5
            },
            "lc": 2,
            "lj": 2,
            "bm": 0,
            "nm": "線 1",
            "mn": "ADBE Vector Graphic - Stroke",
            "hd": false
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [39.268, 32.471],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 3
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 6
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 7
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 4
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 5
            },
            "nm": "トランスフォーム"
          }],
          "nm": "グループ 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        }],
        "ip": 5,
        "op": 10,
        "st": 5,
        "bm": 0
      }, {
        "ddd": 0,
        "ind": 4,
        "ty": 4,
        "nm": "w1アウトライン",
        "parent": 6,
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [48.609, 49.779, 0],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [33.393, 41.843, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100, 100],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "shapes": [{
          "ty": "gr",
          "it": [{
            "ind": 0,
            "ty": "sh",
            "ix": 1,
            "ks": {
              "a": 0,
              "k": {
                "i": [[0, 0], [0, 0]],
                "o": [[0, 0], [0, 0]],
                "v": [[-11.88, -3.482], [11.88, 3.482]],
                "c": false
              },
              "ix": 2
            },
            "nm": "パス 1",
            "mn": "ADBE Vector Shape - Group",
            "hd": false
          }, {
            "ty": "st",
            "c": {
              "a": 0,
              "k": [0.239215701234, 0.701960784314, 0.847058883368, 1],
              "ix": 3
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 4
            },
            "w": {
              "a": 0,
              "k": 4,
              "ix": 5
            },
            "lc": 2,
            "lj": 2,
            "bm": 0,
            "nm": "線 1",
            "mn": "ADBE Vector Graphic - Stroke",
            "hd": false
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [17.417, 41.381],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 3
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 6
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 7
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 4
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 5
            },
            "nm": "トランスフォーム"
          }],
          "nm": "グループ 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }, {
          "ty": "gr",
          "it": [{
            "ind": 0,
            "ty": "sh",
            "ix": 1,
            "ks": {
              "a": 0,
              "k": {
                "i": [[0, 0], [0, 0]],
                "o": [[0, 0], [0, 0]],
                "v": [[-13.314, -10.652], [13.314, 10.652]],
                "c": false
              },
              "ix": 2
            },
            "nm": "パス 1",
            "mn": "ADBE Vector Shape - Group",
            "hd": false
          }, {
            "ty": "st",
            "c": {
              "a": 0,
              "k": [0.239215701234, 0.701960784314, 0.847058883368, 1],
              "ix": 3
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 4
            },
            "w": {
              "a": 0,
              "k": 4,
              "ix": 5
            },
            "lc": 2,
            "lj": 2,
            "bm": 0,
            "nm": "線 1",
            "mn": "ADBE Vector Graphic - Stroke",
            "hd": false
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [27.863, 20.284],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 3
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 6
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 7
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 4
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 5
            },
            "nm": "トランスフォーム"
          }],
          "nm": "グループ 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        }, {
          "ty": "gr",
          "it": [{
            "ind": 0,
            "ty": "sh",
            "ix": 1,
            "ks": {
              "a": 0,
              "k": {
                "i": [[0, 0], [0, 6.015], [-23.077, 0]],
                "o": [[-2.288, -5.167], [0, -23.078], [0, 0]],
                "v": [[-17.334, 29.343], [-20.893, 12.443], [20.893, -29.343]],
                "c": false
              },
              "ix": 2
            },
            "nm": "パス 1",
            "mn": "ADBE Vector Shape - Group",
            "hd": false
          }, {
            "ty": "st",
            "c": {
              "a": 0,
              "k": [0.239215701234, 0.701960784314, 0.847058883368, 1],
              "ix": 3
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 4
            },
            "w": {
              "a": 0,
              "k": 4,
              "ix": 5
            },
            "lc": 2,
            "lj": 2,
            "bm": 0,
            "nm": "線 1",
            "mn": "ADBE Vector Graphic - Stroke",
            "hd": false
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [33.393, 41.843],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 3
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 6
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 7
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 4
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 5
            },
            "nm": "トランスフォーム"
          }],
          "nm": "グループ 3",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        }],
        "ip": 0,
        "op": 5,
        "st": 0,
        "bm": 0
      }, {
        "ddd": 0,
        "ind": 6,
        "ty": 0,
        "nm": "warau_eye2",
        "refId": "comp_0",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 1,
            "k": [{
              "i": {
                "x": 0.667,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 0,
              "s": [119.5, 56.75, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            }, {
              "i": {
                "x": 0.667,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 3,
              "s": [119.5, 60.75, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            }, {
              "i": {
                "x": 0.667,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 6,
              "s": [119.5, 56.75, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            }, {
              "i": {
                "x": 0.667,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 9,
              "s": [119.5, 60.75, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            }, {
              "i": {
                "x": 0.667,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 12,
              "s": [119.5, 56.75, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            }, {
              "i": {
                "x": 0.667,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 15,
              "s": [119.5, 60.75, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            }, {
              "t": 18,
              "s": [119.5, 56.75, 0]
            }],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [119.5, 66, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100, 100],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "hasMask": true,
        "masksProperties": [{
          "inv": false,
          "mode": "n",
          "pt": {
            "a": 0,
            "k": {
              "i": [[0, 0]],
              "o": [[0, 0]],
              "v": [[274.5, 41.04]],
              "c": false
            },
            "ix": 1
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 3
          },
          "x": {
            "a": 0,
            "k": 0,
            "ix": 4
          },
          "nm": "マスク 1"
        }],
        "w": 239,
        "h": 132,
        "ip": 0,
        "op": 18,
        "st": 0,
        "bm": 0
      }, {
        "ddd": 0,
        "ind": 7,
        "ty": 0,
        "nm": "warau_eye1",
        "refId": "comp_1",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 1,
            "k": [{
              "i": {
                "x": 0.667,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 0,
              "s": [119.5, 56.75, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            }, {
              "i": {
                "x": 0.667,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 3,
              "s": [119.5, 60.75, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            }, {
              "i": {
                "x": 0.667,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 6,
              "s": [119.5, 56.75, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            }, {
              "i": {
                "x": 0.667,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 9,
              "s": [119.5, 60.75, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            }, {
              "i": {
                "x": 0.667,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 12,
              "s": [119.5, 56.75, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            }, {
              "i": {
                "x": 0.667,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 15,
              "s": [119.5, 60.75, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            }, {
              "t": 18,
              "s": [119.5, 56.75, 0]
            }],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [119.5, 66, 0],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100, 100],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "w": 239,
        "h": 132,
        "ip": 0,
        "op": 18,
        "st": 0,
        "bm": 0
      }],
      "markers": []
    };
    let anim01;
    const params01 = {
      container: document.getElementById('js-lottie01'),
      renderer: 'svg',
      loop: false,
      autoplay: false,
      // path: this.getPath() + 'mabataki.json',
      animationData: animationData01
    };
    anim01 = lottie.loadAnimation(params01);
    let anim02;
    const params02 = {
      container: document.getElementById('js-lottie02'),
      renderer: 'svg',
      loop: false,
      autoplay: false,
      // path: this.getPath() + 'erabu.json',
      animationData: animationData02
    };
    anim02 = lottie.loadAnimation(params02);
    let anim03;
    const params03 = {
      container: document.getElementById('js-lottie03'),
      renderer: 'svg',
      loop: false,
      autoplay: false,
      // path: this.getPath() + 'sorasu.json',
      animationData: animationData03
    };
    anim03 = lottie.loadAnimation(params03);
    let anim04;
    const params04 = {
      container: document.getElementById('js-lottie04'),
      renderer: 'svg',
      loop: false,
      autoplay: false,
      // path: this.getPath() + 'kirakira.json',
      animationData: animationData04
    };
    anim04 = lottie.loadAnimation(params04);
    let anim05;
    const params05 = {
      container: document.getElementById('js-lottie05'),
      renderer: 'svg',
      loop: false,
      autoplay: false,
      // path: this.getPath() + 'mabataki.json',
      animationData: animationData01
    };
    anim05 = lottie.loadAnimation(params05);
    let anim06;
    const params06 = {
      container: document.getElementById('js-lottie06'),
      renderer: 'svg',
      loop: false,
      autoplay: false,
      // path: this.getPath() + 'warai.json',
      animationData: animationData05
    };
    anim06 = lottie.loadAnimation(params06);
    tl.to($('#js-lottie01'), {
      duration: 1,
      delay: 1,
      onStart: () => {
        anim01.play();
      },
      onComplete: () => {
        $('#js-lottie01').addClass('--hidden');
        anim01.goToAndStop(0);
      }
    }).to($('#js-lottie02'), {
      duration: 6,
      onStart: () => {
        anim02.play();
      },
      onComplete: () => {
        $('#js-lottie02').addClass('--hidden');
        anim02.goToAndStop(0);
      }
    }).to($('#js-lottie03'), {
      duration: 5,
      onStart: () => {
        anim03.play();
      },
      onComplete: () => {
        $('#js-lottie03').addClass('--hidden');
        anim03.goToAndStop(0);
      }
    }).to($('#js-lottie04'), {
      duration: 4,
      onStart: () => {
        anim04.play();
      },
      onComplete: () => {
        $('#js-lottie04').addClass('--hidden');
        anim04.goToAndStop(0);
      }
    }).to($('#js-lottie05'), {
      duration: 1,
      onStart: () => {
        anim05.play();
      },
      onComplete: () => {
        $('#js-lottie05').addClass('--hidden');
        anim05.goToAndStop(0);
      }
    }).to($('#js-lottie06'), {
      duration: 1,
      onStart: () => {
        anim06.play();
      },
      onComplete: () => {
        $('.--anim').removeClass('--hidden');
        anim06.goToAndStop(0);
      }
    });
  }

}

class keyVisual {
  constructor() {
    this.$els = $('[data-slider]');
    this.sliders = []; // [{$el: $el, type: type, slider: slider}]

    if (!this.$els.length) {
      return;
    }

    this.init();
  }

  init() {
    console.log('kv');
    this.$els.each((_i, _e) => {
      const type = $(_e).data('slider');
      this.slider(_e);
    });
  }

  slider(_el) {
    let el = $(_el).find('.swiper')[0];
    const slider = new Swiper(el, {
      loop: true,
      loopedSlides: 10,
      slidesPerView: 'auto',
      centeredSlides: true,
      initialSlide: 2,
      breakpoints: {
        320: {
          slidesPerView: 'auto',
          spaceBetween: 16
        },
        769: {
          slidesPerView: 'auto',
          spaceBetween: 46.25
        }
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"></span>';
        }
      },
      autoplay: {
        delay: 6000,
        disableOnInteraction: false
      },
      on: {
        init: swiper => {
          this.updateSlideScales(swiper);
        },
        slideChange: swiper => {
          this.updateSlideScales(swiper);
        }
      }
    });
    this.sliders.push({
      $el: $(el),
      type: 'kv-slider',
      slider: slider
    });
    $(window).on('loadend', () => {// slider.autoplay.start();
    });
    window.addEventListener('resize', () => {
      slider.update();
    });
  }

  updateSlideScales(swiper) {
    const slides = swiper.slides;
    const activeIndex = swiper.activeIndex;
    const totalSlides = slides.length;
    slides.forEach((slide, index) => {
      let scale = 0.75;
      let translateX = '0%';
      let zIndex = 0; // Calculate the minimum distance to the active slide, considering loop

      const distanceToActive = Math.min(Math.abs(index - activeIndex), Math.abs(index - activeIndex + totalSlides), Math.abs(index - activeIndex - totalSlides));

      if (distanceToActive === 0) {
        // Active slide
        scale = 1;
        zIndex = 2;
      } else if (distanceToActive === 2) {
        // Slides two positions away from active (prev's previous and next's next)
        translateX = index < activeIndex ? '20%' : '-20%';
        zIndex = 0;
      } // Apply transformations


      slide.style.transform = `scale(${scale}) translateX(${translateX})`;
      slide.style.zIndex = zIndex;
    });
  }

}

(() => {})(); //DOMContentLoaded


$(() => {}); //images resources loaded

$(window).on('load', () => {
  const header = new jsHeader();
  const pagetop = new pageTop();
  const page_collection = new pageCollection();
  const page_product = new pageProduct();
  const page_register = new pageRegister();
  const page_inquiry = new pageInquiry();
  const lottie = new Lottie();
  const kv = new keyVisual();
  $(window).trigger('loading');
}); //after loading animation

$(window).on('loading', () => {}); // スマホ・タブレットの向き判定
// $(window).on('orientationchange', ()=>{
//   if(isPortrait()){
//     console.log('isPortrait');
//   } else {
//     console.log('isLandscape');
//   }
// });
//# sourceMappingURL=../../_cache/_maps/scripts.js.map